










































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import KviCartSelect from '@/components/KviCartSelect.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {ITableHeaders, TableHeaders} from '@/interfaces/components-data';

import {
    CalcIndividualConfig,
    Coefficents,
    ConfigMap,
    FindFiltersParams,
    IndividualConfig,
    SelectBox,
    SelectKviCart,
    SelectMarket, StrategyOfPriceOpt,
    TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    CalcIndividualConfigMap,
    CompetitorsPriceFilter,
    CompetitorsPriceStrategies,
    CompetitorsPricesView,
    GetTaskInfo,
    IndividualConfigCmd,
    InternalCodeAndProductRange,
    InternalCodeAndSkuName,
    KviCartFilters,
    KviCartPackageConfig,
    KviCartsSkuFilter,
    KviShoppingCartFilters,
    KviStrategies,
    PackageKviRecommendsConfig,
    ProductSegmentIdAndName, RegularCompetitorsPricesView,
    Segment,
    Sku, SortingField,
    TaskAndFile,
    TaskData,
    TaskInfoFilterType,
    kviCartChangePricesSb,
    KviRoundingRulesFilter,
    KviRoundingParams,
    AssortmentDirectoryFilterOptions,
    ProductTag,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {BTabs, BvModalEvent, BFormFile} from 'bootstrap-vue';
import moment from 'moment';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import AutoApprovalTab from '@/components/UI/AutoApprovalTab.vue';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import {CompetitorsPriceRow} from "@/interfaces/competitors-price-row";
import {compareNumber, sortByFields} from "@/utils/arrayUtils";
import CollapseCard from './UI/CollapseCard.vue';
import Card from './UI/Card.vue';
import DatePicker from "vue2-datepicker";
import { ILabelAndValue } from "@/interfaces/server-data";

interface CartProductsTableFilterOptions {
    groups: ILabelAndValue<number>[],
    categories: ILabelAndValue<number>[],
    subcategories: ILabelAndValue<number>[],
    formats: ILabelAndValue<number>[],
    regions: ILabelAndValue<number>[],
    clusters: ILabelAndValue<number>[],
    productSegments: ILabelAndValue<number>[],
}

interface CartProductsTableFilterValues {
    group: number,
    category: number,
    subcategory: number,
    formats: number[],
    regions: number[],
    clusters: number[],
    productSegments: number[],
}

interface AddProductsToCartTableFilterOptions {
    groups: ILabelAndValue<number>[],
    categories: ILabelAndValue<number>[],
    subcategories: ILabelAndValue<number>[],
}

interface AddProductsToCartTableFilterValues {
    group: number,
    category: number,
    subcategory: number,
}

@Component({
    components: {
        KviCartSelect,
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        LocalData,
        HintsContainer,
        CollapseCard,
        Card,
        CSelect,
        DatePicker,
        SwitchWithLabel,
        AutoApprovalTab,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD.MM.YYYY');
            }
        },
        formatCompetitorsDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('YYYY-MM-DD');
            }
        },
    },
    methods: {
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    return 'table-primary';
                }
                if (item.resultType === 'COMPETITOR') {
                    return 'table-danger';
                }
            }
        },
        formatNumber(number) {
            if (String(number)[0] === '-') {
                return String(number).substring(0, 4);
            } else {
                return String(number).substring(0, 3);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
    },
})
export default class KviShoppingCart extends Mixins(LocalData, Toast, Http) {
    localSelectKviCart: SelectKviCart = {id: -1, kviCartName: this.$t('kviCarts.labels.selectCart') as string}
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    selectProductLine: string = {value: 'all', label: this.$t('shared.boolFilter.all') as string}.value;

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('shared.boolFilter.all') as string};
    selectKVI: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;

    selectFilterProductSegment: number = this.defaultFilterValue.value;

    sortingField: SortingField | null = null
    sortByInternalCode: number = -1;
    sortByStoreFormat: number = -1;
    sortByStoreRegion: number = -1;
    sortBySkuName: number = -1;
    sortByCompetitorName: number = -1;
    sortByCompetitorPriority: number = -1;
    sortByLastPrice: number = -1;
    sortByPromoPrice: number = -1;
    sortByCompetitorPrice: number = -1;
    sortByDelta: number = -1;
    sortByKvi: number = -1;
    sortByCtm: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsOne: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsTwo: number = -1;
    sortByCompetitorDate: number = -1;

    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.boolFilter.all') as string},
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('shared.selectBox.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.boolFilter.all') as string},
        {value: 0, label: this.$t('shared.selectBox.gk') as string},
        {value: 1, label: this.$t('shared.selectBox.cvk') as string},
    ];

    defaultCtmFilterValue = {value: 'all', label: this.$t('shared.boolFilter.all') as string};
    selectCTM: string = this.defaultCtmFilterValue.value;
    ctmOptions: Array<SelectBox<string>> = [
        this.defaultCtmFilterValue,
        {value: '1', label: 'CTM'},
        {value: '0', label: this.$t('shared.selectBox.notCtm') as string},
    ];

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.boolFilter.all') as string}];
    defaultStringSelectBox: Array<SelectBox<string>> = [{value: this.$t('shared.boolFilter.all') as string, label: this.$t('shared.boolFilter.all') as string}];

    selectSegmentPrice: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];
    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    selectedCompetitorsCtmFilter: SelectBox<string> = this.defaultCtmFilterValue;

    selectedCompetitorsKviFilter: SelectBox<number> = this.defaultFilterValue;

    selectedMonitoringDateFilter: string[] = [];
    monitoringDateFilterOptions: Array<SelectBox<string>> = [];

    selectedDeltaFilter: string[] = [];
    deltaFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsPriceFilter: string[] = [];
    competitorsPriceFilterOptions: Array<SelectBox<string>> = [];

    selectedLastPriceFilter: string[] = [];
    lastPriceFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsPriorityFilter: string[] = [];
    competitorsPriorityFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsNameFilter: string[] = [];
    competitorsNameFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsCodeFilter: string[] = [];
    competitorsCodeFilterOptions: Array<SelectBox<string>> = [];

    selectedSkuNameFilter: string[] = [];
    skuNameFilterOptions: Array<SelectBox<string>> = [];

    selectedKeyCharacteristicOneForCompetitors: string[] = [];
    keyCharacteristicOneForCompetitorsOptions: Array<SelectBox<string>> = [];

    selectedKeyCharacteristicTwoForCompetitors: string[] = [];
    keyCharacteristicTwoForCompetitorsOptions: Array<SelectBox<string>> = [];
    currentMainTab: string = "mainParameters"

    competitorsNamesObj: {[key: string]: string[]} = {};

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.boolFilter.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.boolFilter.all') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.boolFilter.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.boolFilter.all') as string}],
        psegemnts: [],
    };

    taskInfoPackageKviRecommends: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.boolFilter.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.boolFilter.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.boolFilter.all') as string}],
        psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    kviCartComponentKey = 1;
    competitorTableKey = 1;
    skuList: Sku[] = [];
    skuListAddProductsToCartModal: Sku[] = []
    cartInternalCodes: string[] = [];
    cartGroups: string[] = [];
    cartCategories: string[] = [];
    cartSubcategories: string[] = [];
    cartProductSegments: string[] = [];
    skuListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    searchable: boolean = true;
    isCalculateButtonLoading: boolean = false;
    isSaveParamsButtonLoading: boolean = false;
    isLoadSkuButtonLoading: boolean = false;
    isSaveIndividualConfigsLoading: boolean = false;
    isDeleteProductsLoading: boolean = false;
    isAddProductsToCartLoading: boolean = false;
    isApplyGlobalIndividualParamsLoading: boolean = false;

    rulesDateRange: string[] = [];
    showDeleteFileModal: boolean = false;
    fileIdForDelete: number = -1;
    usersFioList: Array<SelectBox<string>> = [];
    selectUserFio: string = {value: 'All', label: this.$t('shared.boolFilter.all') as string}.value;
    rulesTableItems: any[] = [];
    isRulesTableLoading: boolean = false;
    isDownloadFileBtnLoading: boolean = false;
    isDeleteFileBtnLoading: boolean = false;
    isDownloadErrorsBtnLoading: boolean = false;
    paginationInRulesTable: any = {
        pageSize: 20,
        current: 1,
        total: 0,
    };

    // tableFields: TableHeaders[] = [
    //     {key: 'selected', label: ''},
    //     {key: 'internalCode', label: this.$t('regular.columns.internalCode') as string},
    //     {key: 'batchNumber', label: this.$t('kviCart.labels.batchNumber') as string},
    //     {key: 'productGroup', label: this.$t('kviCart.labels.productGroup') as string},
    //     {key: 'categoryName', label: this.$t('kviCart.labels.productCategory') as string},
    //     {key: 'subcategory', label: this.$t('kviCart.labels.productSubcategory') as string},
    //     {key: 'productSegmentName', label: this.$t('kviCart.labels.productSegments') as string},
    //     {key: 'skuName', label: 'SKU'},
    //     {key: 'keyCharacteristicOfTheProductIsOne', label: this.$t('kviCart.labels.kht1') as string},
    //     {key: 'keyCharacteristicOfTheProductIsTwo', label: this.$t('kviCart.labels.kht2') as string},
    //     {key: 'recipeAttribute', label: this.$t('kviCart.labels.prc') as string},
    //     {key: 'treatmentAttribute', label: this.$t('kviCart.labels.pkl') as string},
    //     {key: 'kvi', label: 'KVI'},
    //     {key: 'tagsKvi', label: ''},
    //     {key: 'ctm', label: 'CTM'},
    //     {key: 'minMaxRetailPrice', label: this.$t('kviCart.labels.minMaxRc') as string},
    //     {key: 'productRange', label: this.$t('kviCart.labels.productRange') as string},
    //     {key: 'lastPrice', label: this.$t('kviCart.labels.lastPrice') as string},
    //     {key: 'priceSegment', label: this.$t('kviCart.labels.priceSegment') as string},
    //     {key: 'lastPriceMarginPc', label: this.$t('kviCart.labels.lastPriceMargin') as string},
    //     {key: 'actualProfitability', label: this.$t('kviCart.labels.actualProfitability') as string},
    //     {key: 'purchasePriceAvgM', label: this.$t('kviCart.labels.avgPurchasePrice') as string},
    //     {key: 'coefficentList', label: this.$t('kviCart.labels.priceOptimizationStrategy') as string},
    //     {key: 'priceIncreaseLimit', label: this.$t('kviCart.labels.priceIncreaseLimit') as string},
    //     {key: 'periodPriceIncreaseLimit', label: this.$t('kviCart.labels.periodPriceIncreaseLimit') as string},
    //     {key: 'period', label: this.$t('kviCart.labels.period') as string},
    //     {key: 'marginalProfit', label: this.$t('kviCart.labels.minProfitabilitySku') as string},
    //     {key: 'kviStrategy', label: this.$t('kviCart.labels.kviStrategy') as string},
    //     {key: 'percentageOfCompetitorsPrice', label: this.$t('kviCart.labels.correction') as string},
    // ];

    modalTopFilters: {
        groupsOfProduct: number[],
        categories: number[],
        subcategories: number[],
    } = {
        groupsOfProduct: [],
        categories: [],
        subcategories: [],
    };

    cartProductsTableFilterOptions: CartProductsTableFilterOptions = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
        productSegments: [],
    };

    cartProductsTableFilterValues: CartProductsTableFilterValues = {
        group: this.defaultFilterValue.value,
        category: this.defaultFilterValue.value,
        subcategory: this.defaultFilterValue.value,
        formats: [],
        regions: [],
        clusters: [],
        productSegments: [],
    };

    addProductsToCartTableFilterOptions: AddProductsToCartTableFilterOptions = {
        groups: [],
        categories: [],
        subcategories: [],
    };

    addProductsToCartTableFilterValues: AddProductsToCartTableFilterValues = {
        group: this.defaultFilterValue.value,
        category: this.defaultFilterValue.value,
        subcategory: this.defaultFilterValue.value,
    };

    addProductsModalTableColumns: any[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected' }, width: 50},
        {dataIndex: 'internalCode', title: this.$t('regular.columns.internalCode') as string, width: 100},
        {dataIndex: 'batchNumber', title: this.$t('regular.columns.batchNumber') as string, width: 80},
        {
            dataIndex: 'productGroup',
            title: this.$t('regular.columns.productGroup') as string,
            width: 150,
            filterModelKey: 'group',
            filterOptionsKey: 'groups',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {
            dataIndex: 'categoryName',
            title: this.$t('regular.columns.productCategory') as string,
            width: 150,
            filterModelKey: 'category',
            filterOptionsKey: 'categories',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {
            dataIndex: 'subcategory',
            title: this.$t('regular.columns.productSubcategory') as string,
            width: 170,
            filterModelKey: 'subcategory',
            filterOptionsKey: 'subcategories',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
        },
        {dataIndex: 'productFormatName', title: this.$t('regular.columns.format') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
        {dataIndex: 'productRegionNames', title: this.$t('regular.columns.region') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
        {dataIndex: 'productClusterName', title: this.$t('regular.columns.cluster') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
        {dataIndex: 'productSegmentName', title: this.$t('kviCarts.columns.productSegments') as string, width: 120, scopedSlots: { filterDropdown: 'segmentFilter', filterIcon: 'segmentFilterIcon' }, ellipsis: true},
        {dataIndex: 'skuName', width: 170, slots: { title: 'skuFilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('regular.columns.kht1') as string, width: 120, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('regular.columns.kht2') as string, width: 120, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }, ellipsis: true},
        {dataIndex: 'recipeAttribute', title: this.$t('regular.columns.prc') as string, width: 120, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }, ellipsis: true},
        {dataIndex: 'treatmentAttribute', title: this.$t('regular.columns.pkl') as string, width: 120, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }, ellipsis: true},
        {dataIndex: 'kvi', title: this.$t('kviCarts.columns.kvi') as string, scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 80},
        {dataIndex: 'tagsKvi', title: '', scopedSlots: { customRender: 'tagsKvi', filterDropdown: 'tagsKviFilter', filterIcon: 'tagsKviFilterIcon' }, width: 100},
        {dataIndex: 'ctm', title: 'CTM', width: 70, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true},
        {dataIndex: 'minMaxRetailPrice', title: this.$t('kviCarts.columns.minMaxRetailPrice') as string, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.minRetailPrice) ? this.numberFormatter(item.minRetailPrice) : '-'}/${(item.maxRetailPrice) ? this.numberFormatter(item.maxRetailPrice) : '-'}`},
        {dataIndex: 'productRange', title: this.$t('kviCarts.columns.productRange') as string, scopedSlots: { customRender: 'productRange', filterDropdown: 'productRangeFilter', filterIcon: 'productRangeFilterIcon' }, width: 130, ellipsis: true},
        {dataIndex: 'lastPrice', scopedSlots: { title: 'lastPriceTitle' }, width: 130, customRender: (value: any) => value ? this.numberFormatter(value) : '-', ellipsis: true},
        {dataIndex: 'priceSegment', title: this.$t('regular.columns.priceSegment') as string, scopedSlots: { filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.priceSegmentMin) ? this.numberFormatter(item.priceSegmentMin) : ''} - ${(item.priceSegmentMax) ? this.numberFormatter(item.priceSegmentMax) : ''}`},
        {dataIndex: 'lastPriceMarginPc', title: this.$t('kviCarts.columns.lastPriceMarginPc') as string, width: 150, ellipsis: true},
        {dataIndex: 'actualProfitability', scopedSlots: { title: 'actualProfitabilityTitle' }, width: 120, ellipsis: true, customRender: (value: any) => this.numberFormatter(value)},
        {
          dataIndex: 'productVolume',
          title: this.$t('regular.columns.vgh') as string,
          customRender: (value: any) => this.numberFormatter(value),
          ellipsis: false,
          width: 40,
        },
        {
          dataIndex: 'measurementUnit',
          title: this.$t('regular.columns.unit') as string,
          ellipsis: false,
          width: 35,
        },
        {
          dataIndex: 'productVerticalLine',
          title: this.$t('regular.columns.vlName') as string,
          ellipsis: true,
          width: 75,
        },
        {
          dataIndex: 'isVerticalLineBase',
          title: this.$t('kviCarts.columns.vlBase') as string,
          customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
          ellipsis: false,
          width: 60,
        },
        {
          dataIndex: 'vlStrategyStr',
          title: this.$t('kviCarts.columns.vlStrategy') as string,
          ellipsis: false,
          width: 75,
        },
        {
          dataIndex: 'vlGapPc',
          title: this.$t('kviCarts.columns.vlGapPc') as string,
          customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
          ellipsis: false,
          width: 70,
        },
    ];

    cartProductsTableColumns: any[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected' }, width: 50},
        {dataIndex: 'internalCode', title: this.$t('regular.columns.internalCode') as string, width: 100},
        {dataIndex: 'batchNumber', title: this.$t('regular.columns.batchNumber') as string, width: 80},
        {
            dataIndex: 'productGroup',
            title: this.$t('regular.columns.productGroup') as string,
            filterModelKey: 'group',
            filterOptionsKey: 'groups',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'categoryName',
            title: this.$t('regular.columns.productCategory') as string,
            filterModelKey: 'category',
            filterOptionsKey: 'categories',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'subcategory',
            title: this.$t('regular.columns.productSubcategory') as string,
            filterModelKey: 'subcategory',
            filterOptionsKey: 'subcategories',
            scopedSlots: {
                filterDropdown: 'filterRadioButtons',
                filterIcon: "filterIcon",
            },
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'productFormatName',
            title: this.$t('regular.columns.format') as string,
            filterModelKey: 'formats',
            filterOptionsKey: 'formats',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 120,
            ellipsis: true,
        },
        {
            dataIndex: 'productRegionNames',
            title: this.$t('regular.columns.region') as string,
            filterModelKey: 'regions',
            filterOptionsKey: 'regions',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            ellipsis: true,
            width: 120,
        },
        {
            dataIndex: 'productClusterName',
            title: this.$t('regular.columns.cluster') as string,
            filterModelKey: 'clusters',
            filterOptionsKey: 'clusters',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 120,
            ellipsis: true
        },
        {
            dataIndex: 'productSegmentName',
            title: this.$t('kviCarts.columns.productSegments') as string,
            filterModelKey: 'productSegments',
            filterOptionsKey: 'productSegments',
            scopedSlots: {
                filterDropdown: 'filterCheckboxes',
                filterIcon: "filterIcon",
            },
            width: 120,
            ellipsis: true
        },
        {dataIndex: 'skuName', width: 170, slots: { title: 'skuFilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('regular.columns.kht1') as string, width: 120, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }, ellipsis: true},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('regular.columns.kht2') as string, width: 120, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }, ellipsis: true},
        {dataIndex: 'recipeAttribute', title: this.$t('regular.columns.prc') as string, width: 120, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }, ellipsis: true},
        {dataIndex: 'treatmentAttribute', title: this.$t('regular.columns.pkl') as string, width: 120, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }, ellipsis: true},
        {dataIndex: 'kvi', title: this.$t('kviCarts.columns.kvi') as string, scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 80},
        {dataIndex: 'tagsKvi', title: '', scopedSlots: { customRender: 'tagsKvi', filterDropdown: 'tagsKviFilter', filterIcon: 'tagsKviFilterIcon' }, width: 100},
        {dataIndex: 'ctm', title: 'CTM', width: 70, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true},
        {dataIndex: 'productRange', title: this.$t('kviCarts.columns.productRange') as string, scopedSlots: { customRender: 'productRange', filterDropdown: 'productRangeFilter', filterIcon: 'productRangeFilterIcon' }, width: 130, ellipsis: true},
        {dataIndex: 'lastPrice', scopedSlots: { title: 'lastPriceTitle' }, width: 130, customRender: (value: any) => value ? this.numberFormatter(value) : '-', ellipsis: true},
        {dataIndex: 'priceSegment', title: this.$t('regular.columns.priceSegment') as string, scopedSlots: { filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.priceSegmentMin) ? this.numberFormatter(item.priceSegmentMin) : ''} - ${(item.priceSegmentMax) ? this.numberFormatter(item.priceSegmentMax) : ''}`},
        {dataIndex: 'lastPriceMarginPc', title: this.$t('kviCarts.columns.lastPriceMarginPc') as string, width: 150, ellipsis: true},
        {dataIndex: 'actualProfitability', scopedSlots: { title: 'actualProfitabilityTitle' }, width: 120, ellipsis: true, customRender: (value: any) => this.numberFormatter(value)},
        {dataIndex: 'purchasePriceAvgM', title: this.$t('kviCarts.columns.avgPurchasePrice') as string, scopedSlots: { customRender: 'purchasePriceAvgM' }, width: 100, ellipsis: true, customRender: (value: any) => this.numberFormatter(value)},
        {dataIndex: 'competitorNames', title: this.$t('regular.columns.competitor') as string, scopedSlots: {customRender: 'competitorNames'}, width: 140},
        {dataIndex: 'coefficentList', title: this.$t('regular.columns.priceOptStrategy') as string, scopedSlots: { customRender: 'coefficentList' }, width: 200, ellipsis: true},
        {dataIndex: 'priceIncreaseLimit', title: this.$t('kviCarts.columns.priceIncreaseLimit') as string, scopedSlots: { customRender: 'priceIncreaseLimit' }, width: 150},
        {dataIndex: 'periodPriceIncreaseLimit', title: this.$t('kviCarts.columns.periodPriceIncreaseLimit') as string, scopedSlots: { customRender: 'periodPriceIncreaseLimit' }, width: 160},
        {dataIndex: 'period', title: this.$t('regular.columns.period') as string, scopedSlots: { customRender: 'period' }, width: 80},
        {dataIndex: 'marginalProfit', title: this.$t('kviCarts.columns.minProfitability') as string, scopedSlots: { customRender: 'marginalProfit' }, width: 150},
        {dataIndex: 'marginalProfitKvi', title: this.$t('kviCarts.columns.minProfitabilityKvi') as string, scopedSlots: { customRender: 'marginalProfitKvi' }, width: 150},
        {dataIndex: 'marginalProfitCompetitors', title: this.$t('kviCarts.columns.minProfitabilityCompetitors') as string, scopedSlots: { customRender: 'marginalProfitCompetitors' }, width: 170},
        {dataIndex: 'maxMarginalProfit', title: this.$t('kviCarts.columns.maxProfitability') as string, scopedSlots: { customRender: 'maxMarginalProfit' }, width: 150},
        {dataIndex: 'kviStrategy', title: this.$t('kviCarts.columns.kviStrategy') as string, scopedSlots: { customRender: 'kviStrategy' }, width: 130, ellipsis: true},
        {dataIndex: 'percentageOfCompetitorsPrice', title: this.$t('regular.columns.adjustment') as string, scopedSlots: { customRender: 'percentageOfCompetitorsPrice' }, width: 100},
        {
          dataIndex: 'productVolume',
          title: this.$t('regular.columns.vgh') as string,
          customRender: (value: any) => this.numberFormatter(value),
          ellipsis: false,
          width: 40,
        },
        {
          dataIndex: 'measurementUnit',
          title: this.$t('regular.columns.unit') as string,
          ellipsis: false,
          width: 35,
        },
        {
          dataIndex: 'productVerticalLine',
          title: this.$t('regular.columns.vlName') as string,
          ellipsis: true,
          width: 75,
        },
        {
          dataIndex: 'isVerticalLineBase',
          title: this.$t('kviCarts.columns.vlBase') as string,
          customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
          ellipsis: false,
          width: 60,
        },
        {
          dataIndex: 'vlStrategyStr',
          title: this.$t('kviCarts.columns.vlStrategy') as string,
          ellipsis: false,
          width: 75,
        },
        {
          dataIndex: 'vlGapPc',
          title: this.$t('kviCarts.columns.vlGapPc') as string,
          customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
          ellipsis: false,
          width: 70,
        },
    ];

    rulesTableFields: TableHeaders[] | ITableHeaders[] = [
        {dataIndex: 'fileDownload', title: this.$t('regular.columns.actions') as string, scopedSlots: {customRender: 'fileDownload'}},
        {dataIndex: 'errors', title: this.$t('regular.columns.errors') as string, scopedSlots: {customRender: 'errors'}},
        {
            dataIndex: 'kviCartId',
            title: this.$t('kviCarts.columns.cartCol') as string,
            scopedSlots: {
                customRender: 'kviCart',
            },
            ellipsis: true,
        },
        {
            dataIndex: 'uploadDate',
            title: this.$t('kviCarts.columns.modificationDate') as string,
            scopedSlots: {filterDropdown: 'uploadDateFilter', filterIcon: 'uploadDateFilterIcon'},
            customRender: (v: number) => moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss'),
            ellipsis: true
        },
        {
            dataIndex: 'user',
            title: this.$t('regular.columns.user') as string,
            // scopedSlots: {filterDropdown: 'userFilter', filterIcon: 'userFilterIcon'},
            ellipsis: true
        },
    ];

    file: File | null = null;

    pagination: any = {
        pageSize: 20,
        current: 1,
    };
    paginationInModal: any = {
      pageSize: 20,
      current: 1,
    };
    paginationInCompetitors: any = {
      pageSize: 20,
      current: 1,
    };

    competitorsTableFields: TableHeaders[] = [
        {key: 'selected', label: ''},
        {key: 'internalCode', label: this.$t('regular.columns.internalCode') as string},
        {key: 'storeFormat', label: this.$t('regular.columns.format') as string},
        {key: 'storeRegion', sortable: true, label: this.$t('regular.columns.region') as string},
        {key: 'skuName', sortable: true, label: this.$t('regular.columns.skuName') as string},
        {key: 'competitorName', sortable: true, label: this.$t('regular.columns.competitor') as string},
        {key: 'competitorPriority', sortable: true, label: this.$t('kviCarts.columns.competitorPriority') as string},
        {key: 'lastPrice', sortable: true, label: this.$t('kviCarts.columns.ourPrice') as string},
        {key: 'competitorPrice', sortable: true, label: this.$t('kviCarts.columns.competitorPrice') as string},
        {key: 'delta', sortable: true, label: this.$t('regular.columns.deviation') as string},
        {key: 'kvi', sortable: true, label: 'KVI'},
        {key: 'ctm', sortable: true, label: this.$t('regular.columns.ctm') as string},
        {key: 'keyCharacteristicOfTheProductIsOne', sortable: true, label: this.$t('regular.columns.kht1') as string},
        {key: 'keyCharacteristicOfTheProductIsTwo', sortable: true, label: this.$t('regular.columns.kht2') as string},
        {key: 'competitorDate', sortable: true, label: this.$t('regular.columns.monitoringDate') as string},
    ];

    newCompetitorsTableFields: any[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected' }, width: 50},
        {dataIndex: 'internalCode', title: this.$t('regular.columns.internalCode') as string, ellipsis: true, width: 150},
        {dataIndex: 'storeFormat', title: this.$t('regular.columns.format') as string, ellipsis: true, width: 150},
        {dataIndex: 'storeRegion', sorter: () => false, title: this.$t('regular.columns.region') as string, scopedSlots: { filterDropdown: 'storeRegionFilter', filterIcon: 'storeRegionFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'skuName', sorter: () => false, title: this.$t('regular.columns.skuName') as string, scopedSlots: { filterDropdown: 'skuNameFilter', filterIcon: 'skuNameFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'competitorName', sorter: () => false, title: this.$t('regular.columns.competitor') as string, scopedSlots: { filterDropdown: 'competitorNameFilter', filterIcon: 'competitorNameFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'competitorCode', sorter: () => false, title: this.$t('regular.columns.competitorCode') as string, scopedSlots: { filterDropdown: 'competitorsCodeFilter', filterIcon: 'competitorsCodeFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'competitorPriority', sorter: () => false, title: this.$t('kviCarts.columns.competitorPriority') as string, scopedSlots: { filterDropdown: 'competitorPriorityFilter', filterIcon: 'competitorPriorityFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'lastPrice', sorter: () => false, title: this.$t('kviCarts.columns.ourPrice') as string, scopedSlots: { filterDropdown: 'lastPriceFilter', filterIcon: 'lastPriceFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'competitorPrice', sorter: (a: any, b: any) => a.competitorPrice - b.competitorPrice, title: this.$t('kviCarts.columns.competitorPrice') as string, customRender: (value: number) => this.numberFormatter(value), scopedSlots: { filterDropdown: 'competitorPriceFilter', filterIcon: 'competitorPriceFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'delta', sorter: () => false, title: this.$t('regular.columns.deviation') as string, customRender: (value: number) => value.toFixed(2), scopedSlots: { filterDropdown: 'deltaFilter', filterIcon: 'deltaFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'kvi', sorter: () => false, title: this.$t('kviCarts.columns.kvi') as string, customRender: (value: number) => value ? this.$t('shared.boolFilter.yes') as string : this.$t('shared.boolFilter.no') as string, scopedSlots: { filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'ctm', sorter: () => false, title: this.$t('regular.columns.ctm') as string, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'keyCharacteristicOfTheProductIsOne', sorter: () => false, title: this.$t('regular.columns.kht1') as string, scopedSlots: { filterDropdown: 'keyCharacteristicOfTheProductIsOneFilter', filterIcon: 'keyCharacteristicOfTheProductIsOneFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'keyCharacteristicOfTheProductIsTwo', sorter: () => false, title: this.$t('regular.columns.kht2') as string, scopedSlots: { filterDropdown: 'keyCharacteristicOfTheProductIsTwoFilter', filterIcon: 'keyCharacteristicOfTheProductIsTwoFilterIcon' }, ellipsis: true, width: 200},
        {dataIndex: 'competitorDate', sorter: () => false, title: this.$t('regular.columns.monitoringDate') as string, customRender: (value: number) => moment(new Date(+value)).format('DD.MM.YYYY'), scopedSlots: { filterDropdown: 'competitorDateFilter', filterIcon: 'competitorDateFilterIcon' }, ellipsis: true, width: 200},
    ];

    competitors: CompetitorsPriceRow[] = [];
    viewCompetitors: CompetitorsPriceRow[] = [];
    skuListLimit: number = 20;
    skuFilter: string = '';
    skuFilterAddProductModal: string = '';
    debounceMinRetailPrice!: () => void;
    serverConfigTimeout: number | null = null;
    loadingConfigs = false;
    marginalErrorText = '';
    globalIndividualMarginalErrorText = '';
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;
    marginalSkuErrorText = '';
    maxProfitKVIErrorText = '';
    competitorsMaximumProfitErrorText = '';
    maxMarginalErrorText = '';

    taskData: TaskAndFile | null = null;
    skuListPerPage: number = 20;
    competitorsListPerPage: number = 50;
    skuListCurrentPage: number = 1;
    competitorsListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    competitorsTotalRows: number = 250;
    calcSkuLastPricesButtonDisabled: boolean = false;
    calcSkuActualProfitButtonDisabled: boolean = false;
    firstDate: number = 0;
    lastDate: number = 0;
    showBookmarks: boolean = true;
    showKviRecommendsBookmarks: boolean = true;
    showMainFilters: boolean = true;
    showKviRecommendsMainFilters: boolean = true;
    needLoadSkuList = false;
    isActualProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isDataRangeCalculated: boolean = false;
    isFetchSkuListDownload: boolean = false;
    isAddProductsToCartTableLoading: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    existsInOtherCartModal: boolean = false;
    kviSaveProcess: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    tabs: BTabs | null = null;
    showSkuAndSearch: boolean = true;
    findAutomaticallyKviRecommendsPriceSegments = false;
    private globalIndividualPriceStrategy: SelectBox<Coefficents> | null = null;
    private globalIndividualPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriodPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriod: SelectBox<number> | null = null;
    private globalIndividualMarginalProfitability: number | null = null;
    private globalIndividualKviStrategy: SelectBox<KviStrategies> | null = null;

    private globalIndividualPercentageOfCompetitorsPrice: string | null = null;
    private refreshSkuListId = -1;
    private refreshTabPanelSkuListId = -1;

    private skuListWithCalculating: boolean = false;
    private sortBySKU: number = -1;
    private dropDownOpen = false;
// tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;
    private actualProfitability: number | null = null;
    private regularPricesProfitability: number | null = null;
    private isFiltersChanged = 1;
    private lastPage = 0;
    private productCodesForAddKvi: string[] = []
    private productCodesForDeleteKvi: string[] = []
    private productCodesForAddCtmPurpose: string[] = []
    private productCodesForDeleteCtmPurpose: string[] = []
    private needCalculateSkuLastPricesOnly: boolean = false;
    private needCalculateSkuActualProfitabilityOnly: boolean = false;

    private httpExecutor: HttpExecutor = new HttpExecutor();
    private selectedProductInternalCodes: InternalCodeAndSkuName[] = []
    private kviRecommendsCountPriceSegments = 1;
    private cartInRoundingTab: SelectKviCart = { id: -1, kviCartName: this.$t('kviCarts.labels.selectCartFull') as string };
    private roundingParams: any = {
        pennies: true,
        allNewPricesWithoutPennies: true,
        manualPennies: 99,
        bigDigit: 1000,
        randomPennies: false,
        roundKviCompetitorPrice: false,
        roundPricesWithEqualCompStrategy: true,
    };

    private marketForRoundingTab: SelectMarket | null = null;
    private kviCartComponentKeyInRoundingTab: number = 1;

    numberFormatter = (v: any): string => FormatNumber.format(v);

    mounted() {
        this.tabs = this.$refs.mainTabs as BTabs
        this.$kviCart.kviCartChangePrices = kviCartChangePricesSb.ALL_CART_PRICES
        if (this.$kviCart.selectMarket.id !== -1) {
            const self = this;
            (this.$refs.updateRegionsRef as any).toggleLoading(true);
            // (this.$refs.updateGroupRef as any).toggleLoading(true);
            // (this.$refs.updateCategoryRef as any).toggleLoading(true);
            // (this.$refs.updateSubcategoryRef as any).toggleLoading(true);
            // (this.$refs.updateSegmentRef as any).toggleLoading(true);
            (this.$refs.formatSelectedRef as any).toggleLoading(true);
            (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            self.getRegionInfo();
            self.getFormatInfo();
            self.getClusterInfo();
            self.getGroupInfo();
            self.getCategoryInfo();
            self.getSubcategoryInfo();
            self.getSegmentInfo();
        }

        EventBus.$on('calc', this.onCalcEventReceived);
        EventBus.$on('packageKviRecommends', this.onCalcEventReceived);
        EventBus.$on('tradingNetChanged', this.updateSelectMarket);
        this.$kviCart.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('regular.strategies.maxGrossMargin') as string}

        const marketForRoundingTab = localStorage.getItem('KviRoundingSelectMarket');

        if (marketForRoundingTab) {
            console.log('if (marketForRoundingTab)')

            this.marketForRoundingTab = JSON.parse(marketForRoundingTab);

            this.kviCartComponentKeyInRoundingTab++;
        }

        // this.listCompetitors({}, () => {});
    }

    onSearch() {
        this.pagination.current = 1;
        this.fetchSkuList(true, 1);
        this.refreshSkuTableInPanel()
    }

    onSearchAddProductModal(){
      this.fetchFullSkuList(false, 1);
    }

    onSkuTableChange(pagination: any) {
        this.pagination = { ...pagination };
        this.fetchSkuList();
    }

  onSkuTableModalChange(pagination: any) {
    this.paginationInModal = { ...pagination };
    this.fetchFullSkuList(false);
  }

    // onCompetitorsTableChange(pagination: any) {
    //     this.competitorsListCurrentPage = pagination.current;
    //     this.listCompetitors({}, () => {});
    // }

    isSelectedKviCartProduct(tableProduct: Sku) {
        const index = this.selectedProductInternalCodes.findIndex((selectedProduct: InternalCodeAndSkuName) => {
            return selectedProduct.internalCode === tableProduct.internalCode && selectedProduct.storeFormat === tableProduct.productFormatName
                && selectedProduct.storeRegion === tableProduct.productRegionNames && selectedProduct.storeCluster === tableProduct.productClusterName;
        });

        return index !== -1;
    }

    setSelectedKviCartProduct(sku: Sku, selected: boolean) {
        const index = this.selectedProductInternalCodes.findIndex((selectedProduct: InternalCodeAndSkuName) => {
            return selectedProduct.internalCode === sku.internalCode && selectedProduct.storeFormat === sku.productFormatName
                && selectedProduct.storeRegion === sku.productRegionNames && selectedProduct.storeCluster === sku.productClusterName;
        });

        if (selected) {
            if (index === -1) {
                const nameAndCodeAndFilterParams: InternalCodeAndSkuName = {
                    internalCode: sku.internalCode,
                    skuName: sku.skuName,
                    storeFormat: sku.productFormatName,
                    storeRegion: sku.productRegionNames,
                    storeCluster: sku.productClusterName,
                    kviCartProductId: sku.kviCartProductId
                };
                this.selectedProductInternalCodes.push(nameAndCodeAndFilterParams);
            }
        } else {
            if (index !== -1) {
                this.selectedProductInternalCodes.splice(index, 1);
            }
        }
    }

    getSelectDefaultValue(internalCode: string, field: string) {
        const period = this.getCalcIndividConfig(this.$kviCart.individualCommonParams, internalCode, field as keyof IndividualConfig) as any;
        const value = period && 'value' in period ? period.value : period;
        return value ? (typeof value === 'object' ? value.enum : value) : undefined;
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    private closeExistsInOtherCartModal() {
      this.existsInOtherCartModal = false;
    }

    private onHideExistsInOtherCartModal(bvEvent: BvModalEvent) {
      if (bvEvent.trigger === 'headerclose') {
        this.existsInOtherCartModal = false
      }
    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = []
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('packageKviRecommends', this.onCalcEventReceived);
        EventBus.$off('tradingNetChanged', this.updateSelectMarket);
        this.selectedProductInternalCodes = []
    }

    created() {
        this.httpLoadModuleHints('KviShoppingCart').then((r) => {
            this.$calc.currentModuleHints = r.data
            this.$calc.hintsLoaded = true
        }).catch((e) => {
        });
        if (this.$disallowedModules.includes('kviShoppingCart')) {
            this.$router.replace('/calc');
        }
    }

    resetTables() {
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
    }

    resetActualProfitability() {
        this.actualProfitability = null;
    }

    resetRegularPricesProfitability() {
        this.regularPricesProfitability = null;
    }

    resetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.categoryOfProduct = null;
                this.$kviCart.subcategory = null;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.categoryOptions = [];
                this.taskInfo.subcategories = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.boolFilter.all') as string}];
                this.needCalculateSkuLastPricesOnly = false;
                this.needCalculateSkuActualProfitabilityOnly = false;
                this.calcSkuLastPricesButtonDisabled = false;
                this.calcSkuActualProfitButtonDisabled = false;
                this.getCategoryInfo();
                this.getSubcategoryInfo();
                this.getSegmentInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.resetCartProductsTableFilterOptions();
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.category:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.subcategory = null;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.subcategories = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.boolFilter.all') as string}];
                this.needCalculateSkuLastPricesOnly = false;
                this.needCalculateSkuActualProfitabilityOnly = false;
                this.calcSkuLastPricesButtonDisabled = false;
                this.calcSkuActualProfitButtonDisabled = false;
                this.getSubcategoryInfo();
                this.getSegmentInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.subcategory:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.boolFilter.all') as string}];
                this.needCalculateSkuLastPricesOnly = false;
                this.needCalculateSkuActualProfitabilityOnly = false;
                this.calcSkuLastPricesButtonDisabled = false;
                this.calcSkuActualProfitButtonDisabled = false;
                this.getSegmentInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$kviCart.clusterSelected = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.boolFilter.all') as string}];
                this.needCalculateSkuLastPricesOnly = false;
                this.needCalculateSkuActualProfitabilityOnly = false;
                this.calcSkuLastPricesButtonDisabled = false;
                this.calcSkuActualProfitButtonDisabled = false;
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.format:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$kviCart.clusterSelected = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.boolFilter.all') as string}];
                this.needLoadSkuList = false;
                this.needCalculateSkuLastPricesOnly = false;
                this.needCalculateSkuActualProfitabilityOnly = false;
                this.calcSkuLastPricesButtonDisabled = false;
                this.calcSkuActualProfitButtonDisabled = false;
                this.getRegionInfo();
                this.getClusterInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.region:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.$kviCart.clusterSelected = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.boolFilter.all') as string}];
                this.needLoadSkuList = false;
                this.needCalculateSkuLastPricesOnly = false;
                this.needCalculateSkuActualProfitabilityOnly = false;
                this.calcSkuLastPricesButtonDisabled = false;
                this.calcSkuActualProfitButtonDisabled = false;
                this.getClusterInfo();
                this.isFiltersChanged = 1;
                this.hideSkuPanel();
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
                break;
            case TaskInfoFilterType.cluster:
                this.tableKey = Math.random();
                this.competitorTableKey = Math.random();
                this.sortBySKU = -1;
                this.isFiltersChanged = 1;
                this.needLoadSkuList = false;
                this.needCalculateSkuLastPricesOnly = false;
                this.needCalculateSkuActualProfitabilityOnly = false;
                this.calcSkuLastPricesButtonDisabled = false;
                this.calcSkuActualProfitButtonDisabled = false;
                this.hideSkuPanel();
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.segmentPriceOptions = [];
                this.productSegmentIdAndNameOptions = [];
                this.resetCompetitors();
        }
        this.keyCharacteristicOneOptions = [];
        this.keyCharacteristicTwoOptions = [];
        this.recipeAttributesOptions = [];
        this.treatmentAttributesOptions = [];
        this.resetActualProfitability();
        this.resetRegularPricesProfitability();
        this.taskId = 0;
        this.fileResult = '';
        this.skuListWithCalculating = false;
    }

    iconMode(array: any[]) {
        return (array.length === 1 && !array[0]) || !array.length
    }

    kviRecommendsResetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$packageKviRecommends.categoriesOfProduct = [];
                this.$packageKviRecommends.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoPackageKviRecommends.categoryOptions = [];
                this.taskInfoPackageKviRecommends.subcategories = [];
                this.taskInfoPackageKviRecommends.psegemnts = [];
                this.taskInfoPackageKviRecommends.storeFormatOptions = [];
                this.taskInfoPackageKviRecommends.storeRegionOptions = [];
                this.taskInfoPackageKviRecommends.clusterOptions = [];
                this.getKviRecommendsCategoryInfo(null);
                this.loadKviRecommendsProductsSubcategories();
                this.loadKviRecommendsProductSegments();
                this.getKviRecommendsFormatInfo();
                this.getKviRecommendsRegionInfo();
                this.getKviRecommendsClusterInfo();
                break;
            case TaskInfoFilterType.category:
                this.$packageKviRecommends.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoPackageKviRecommends.subcategories = [];
                this.taskInfoPackageKviRecommends.psegemnts = [];
                this.taskInfoPackageKviRecommends.storeFormatOptions = [];
                this.taskInfoPackageKviRecommends.storeRegionOptions = [];
                this.taskInfoPackageKviRecommends.clusterOptions = [];
                this.loadKviRecommendsProductsSubcategories();
                this.loadKviRecommendsProductSegments();
                this.getKviRecommendsFormatInfo();
                this.getKviRecommendsRegionInfo();
                this.getKviRecommendsClusterInfo();
                break;
            case TaskInfoFilterType.subcategory:
                this.$packageKviRecommends.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoPackageKviRecommends.psegemnts = [];
                this.taskInfoPackageKviRecommends.storeFormatOptions = [];
                this.taskInfoPackageKviRecommends.storeRegionOptions = [];
                this.taskInfoPackageKviRecommends.clusterOptions = [];
                this.loadKviRecommendsProductSegments();
                this.getKviRecommendsFormatInfo();
                this.getKviRecommendsRegionInfo();
                this.getKviRecommendsClusterInfo();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$packageKviRecommends.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoPackageKviRecommends.storeFormatOptions = [];
                this.taskInfoPackageKviRecommends.storeRegionOptions = [];
                this.taskInfoPackageKviRecommends.clusterOptions = [];
                this.getKviRecommendsFormatInfo();
                this.getKviRecommendsRegionInfo();
                this.getKviRecommendsClusterInfo();
                break;
            case TaskInfoFilterType.format:
                this.$packageKviRecommends.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packageKviRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoPackageKviRecommends.storeRegionOptions = [];
                this.taskInfoPackageKviRecommends.clusterOptions = [];
                this.loadKviRecommendsProductSegments();
                this.getKviRecommendsRegionInfo();
                this.getKviRecommendsClusterInfo();
                break;
            case TaskInfoFilterType.region:
                this.$packageKviRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoPackageKviRecommends.clusterOptions = [];
                this.loadKviRecommendsProductSegments();
                this.getKviRecommendsClusterInfo();
                break;
        }
    }

    loadKviRecommendsProductsGroup() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.kviRecommendsGroupOfProductRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfoPackageKviRecommends.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoPackageKviRecommends.groupsOfProduct.unshift({value: 0, label: this.$t('shared.boolFilter.all') as string});
                })
                .catch((e) => {
                })
    }

    loadKviRecommendsProductsSubcategories() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.kviRecommendsSubcategoriesRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfoPackageKviRecommends.subcategories = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoPackageKviRecommends.subcategories.unshift({value: 0, label: this.$t('shared.boolFilter.all') as string})
                })
                .catch((e) => {
                })
    }

    loadKviRecommendsProductSegments() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.p_segemnt))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                    (this.$refs.kviRecommendsProductSegmentsRef as any).toggleLoading(false);
                  }, 250);
                    this.taskInfoPackageKviRecommends.psegemnts = filterData.psegments.map((i) => {
                        return {
                            label: i.name,
                            value: i.id,
                        }
                    });
                    this.taskInfoPackageKviRecommends.psegemnts.unshift({value: 0, label: this.$t('shared.boolFilter.all') as string})
                })
                .catch((e) => {
                });
    }

    resetCompetitors() {
        this.selectedSkuNameFilter = [];
        this.selectedCompetitorsNameFilter = [];
        this.selectedCompetitorsPriorityFilter = [];
        this.selectedLastPriceFilter = [];
        this.selectedCompetitorsPriceFilter = [];
        this.selectedDeltaFilter = [];
        this.selectedCompetitorsKviFilter = this.defaultFilterValue;
        this.selectedCompetitorsCtmFilter = this.defaultCtmFilterValue;
        this.selectedKeyCharacteristicOneForCompetitors = [];
        this.selectedKeyCharacteristicTwoForCompetitors = [];
        this.selectedMonitoringDateFilter = [];
    }

    updateCluster(list: Array<number | null>) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$kviCart.clusterSelected)) {
            this.$kviCart.clusterSelected = list.filter(el => el !== null) as number[];
            this.onDropdownClosed = () => {
                this.saveKviShoppingCart();
                this.resetData(TaskInfoFilterType.cluster);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        }
    }

    updateKviRecommendsProductCategory(categories: number[]) {
        if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$packageKviRecommends.categoriesOfProduct)) {
            this.$packageKviRecommends.categoriesOfProduct = categories;
            this.kviRecommendsResetData(TaskInfoFilterType.category);
            this.savePackageKviRecommends();
        }
    }

    updateKviRecommendsProductGroup(groupOfProduct: number[]) {
        if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$packageKviRecommends.groupsOfProduct)) {
            this.$packageKviRecommends.groupsOfProduct = groupOfProduct;
            this.savePackageKviRecommends();
            this.kviRecommendsResetData(TaskInfoFilterType.group);
        }
    }

    updateKviRecommendsSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageKviRecommends.subcategories)) {
            this.$packageKviRecommends.subcategories = list;
            this.savePackageKviRecommends();
            this.kviRecommendsResetData(TaskInfoFilterType.subcategory);
        }
    }

    updateKviRecommendsProductSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageKviRecommends.productSegments)) {
            this.$packageKviRecommends.productSegments = list;
            this.savePackageKviRecommends();
            this.kviRecommendsResetData(TaskInfoFilterType.p_segemnt);
        }
    }

  updateFormat(format: number) {
    if (format !== this.$kviCart.formatSelected) {
      this.$kviCart.formatSelected = format;
      this.resetData(TaskInfoFilterType.format);
      this.saveKviShoppingCart();
        }
    }

    updateGroup(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.modalTopFilters.groupsOfProduct)) {
            this.modalTopFilters.groupsOfProduct = list;
        }
    }

    updateCategory(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.modalTopFilters.categories)) {
            this.modalTopFilters.categories = list;
        }
    }

    updateSubcategory(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.modalTopFilters.subcategories)) {
            this.modalTopFilters.subcategories = list;
        }
    }

    updateSegment(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$kviCart.productSegments)) {
            this.$kviCart.productSegments = list;
            this.onDropdownClosed = () => {
                this.saveKviShoppingCart();
                this.resetData(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        }
    }

    updateKviRecommendsFormat(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageKviRecommends.formatSelected)) {
            this.$packageKviRecommends.formatSelected = list;
            this.kviRecommendsResetData(TaskInfoFilterType.format);
            this.savePackageKviRecommends();
        }
    }

    updateKviCart(cart: SelectKviCart) {
        this.$kviCart.selectKviCart = cart;

        if (cart.id === -1) {
            this.clearFilters();
        }

        if (this.$kviCart.selectMarket.id !== -1) {
            this.refreshSkuList()
            this.refreshSkuTableInPanel();
        }
    }

    localUpdateKviCart(cart: SelectKviCart) {
        this.localSelectKviCart = cart;
    }

    resetIndividualConfigs() {
        const individualCommonParams = Object.assign({}, this.$kviCart.individualCommonParams);

        Object.keys(individualCommonParams).forEach(internalCode => individualCommonParams[internalCode] = {});

        this.$kviCart.individualCommonParams = individualCommonParams;
    }

    isKviCartSelected(): boolean {
        return this.$kviCart.selectKviCart.id === -1
    }

    isProductsSelected(): boolean {
        return this.selectedProductInternalCodes.length === 0
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$kviCart.regionSelected)) {
            this.$kviCart.regionSelected = list;
            this.onDropdownClosed = () => {
                this.saveKviShoppingCart();
                this.resetData(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        }
    }

    updateKviRecommendsRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageKviRecommends.regionSelected)) {
            this.$packageKviRecommends.regionSelected = list;
            this.kviRecommendsResetData(TaskInfoFilterType.region);
            this.savePackageKviRecommends();
        }
    }

    updateKviRecommendsClusters(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageKviRecommends.clusterSelected)) {
            this.$packageKviRecommends.clusterSelected = list;
            this.kviRecommendsResetData(TaskInfoFilterType.cluster);
            this.savePackageKviRecommends();
        }
    }

    updateKviRecommendsBuyerSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageKviRecommends.buyerSegmentsList)) {
            this.$packageKviRecommends.buyerSegmentsList = list;
            this.savePackageKviRecommends();
        }
    }

    updateKviRecommendsSeasons(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageKviRecommends.seasonSelected)) {
            this.$packageKviRecommends.seasonSelected = list;
            this.savePackageKviRecommends();
        }
    }

    updatePriceSegments(list: Segment[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item.name === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item.name === 'All'
                });
                if (index2 !== -1) {
                    this.selectSegmentPrice = [];
                } else {
                    this.selectSegmentPrice = list;
                }
            } else {
                this.selectSegmentPrice = list;
            }
        }
    }

    updateKeyCharacteristicOne(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicOne = [];
                } else {
                    this.selectKeyCharacteristicOne = list;
                }
            } else {
                this.selectKeyCharacteristicOne = list;
            }
        }
    }

    updateKeyCharacteristicTwo(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicTwo = [];
                } else {
                    this.selectKeyCharacteristicTwo = list;
                }
            } else {
                this.selectKeyCharacteristicTwo = list;
            }
        }
    }

    updateRecipeAttributes(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectRecipeAttributes = [];
                } else {
                    this.selectRecipeAttributes = list;
                }
            } else {
                this.selectRecipeAttributes = list;
            }
        }
    }

    updateTreatmentAttributes(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectTreatmentAttributes = [];
                } else {
                    this.selectTreatmentAttributes = list;
                }
            } else {
                this.selectTreatmentAttributes = list;
            }
        }
    }

    updateProductSegmentIdAndName(list: ProductSegmentIdAndName[]) {
        // Костыль. Фильтрую потому что пришлось сделать :default_value="[{value: -1, label: this.$t('shared.boolFilter.all') as string}]", т.к. класс Multiselect некорректно обрабатывает массив с 2-мя значениями
        // и вариант :default_value="[{value: {segmentId: -1, segmentName: 'All'}, label: this.$t('kviCart.labels.all') as string}]" не срабатывает
        list = list.filter((s) => {
            return typeof s.segmentName !== 'undefined' && typeof s.segmentId !== 'undefined'
        });
        if (list.length > 0) {
            this.selectProductSegmentIdAndName = list;
        } else {
            this.selectProductSegmentIdAndName = [];
        }
    }

    resetDataRange() {
        this.firstDate = 0;
        this.lastDate = 0;
    }

    resetKVIparams() {
        this.useFindKviRecommendsParam = false;
        this.$kviCart.percentageOfRecommendsKviCount = 10;
        this.$kviCart.useSegmentsPriceInSearchKVIRecParam = false;
        this.$kviCart.saveKviSign = false;
    }

    updateKviRecommendsSelectMarket(market: SelectMarket) {
        if (this.$packageKviRecommends.selectMarket == null || this.$packageKviRecommends.selectMarket.id !== market.id) {
            this.resetPackageKviRecommendsData();
            this.$packageKviRecommends.selectMarket = market;
            this.initKviRecommendsTask();
            this.savePackageKviRecommends();
        }
    }

    updateSelectMarket(market: SelectMarket) {
        if (this.$kviCart.selectMarket == null || this.$kviCart.selectMarket.id !== market.id) {
            this.kviCartComponentKey += 1
            this.resetKviShoppingCartData();
            this.$kviCart.selectMarket = market;
            this.skuList = [];
            this.skuListAddProductsToCartModal = [];
            this.paginationInModal = {
                pageSize: 20,
                current: 1,
                };
            this.initTask();
            this.saveKviShoppingCart();
            this.tableKey = Math.random();
            this.competitorTableKey = Math.random();
            this.resetDataRange();
            this.hideSkuPanel();
            this.resetActualProfitability();
            this.resetRegularPricesProfitability();
            this.isFiltersChanged = 1;
            this.resetCompetitors();
            this.needLoadSkuList = false;
            this.needCalculateSkuLastPricesOnly = false;
            this.needCalculateSkuActualProfitabilityOnly = false;
            this.calcSkuLastPricesButtonDisabled = false;
            this.calcSkuActualProfitButtonDisabled = false;
            this.resetKVIparams();
            this.taskId = 0;
            this.fileResult = '';
            this.productCodesForAddKvi = [];
            this.productCodesForDeleteKvi = [];
            this.segmentPriceOptions = [];
            this.productSegmentIdAndNameOptions = [];
            this.keyCharacteristicOneOptions = [];
            this.skuListWithCalculating = false;
            this.$kviCart.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('regular.strategies.maxGrossMargin') as string}
        }
    }

    showRoundPricesWithEqualCompStrategy(): boolean {
        return this.$kviCart.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
                || status === 'EmptyData'
                || status === 'ExecutionException'
                || status.includes('Error'));
    }

    clearFilterDisabled() {
        return !this.skuFilter;
    }

    clearFilter() {
        this.skuFilter = '';
        this.refreshSkuList()
    }

    clearFilterInUpperPanel() {
        this.skuFilter = '';
        this.fetchSkuList(true, 1);
        this.refreshSkuTableInPanel()
    }

  clearFilterAddProductToCartModal() {
    this.skuFilterAddProductModal = '';
    this.fetchFullSkuList(false, 1);
  }

    selectData(isForAddProductsModal: boolean = false): [number[], number[], number[], number[], number[], string | null, Segment[] | null] {
        const selectRegions: number[] = (this.$kviCart.regionSelected.length === 0 || (this.$kviCart.regionSelected.length && this.$kviCart.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$kviCart.regionSelected)!!;

        const selectGroups: number[] = (() => {
            if (isForAddProductsModal) {
                return (this.modalTopFilters.groupsOfProduct.length === 0 || (this.modalTopFilters.groupsOfProduct.length && this.modalTopFilters.groupsOfProduct[0] === 0))
                    ? []
                    : LocalData.filterNumberArrays(this.modalTopFilters.groupsOfProduct)!!;
            } else {
                return (this.$kviCart.groupsOfProduct.length === 0 || (this.$kviCart.groupsOfProduct.length && this.$kviCart.groupsOfProduct[0] === 0))
                    ? []
                    : LocalData.filterNumberArrays(this.$kviCart.groupsOfProduct)!!;
            }
        })();

        const selectCategories: number[] = (() => {
            if (isForAddProductsModal) {
                return (this.modalTopFilters.categories.length === 0 || (this.modalTopFilters.categories.length && this.modalTopFilters.categories[0] === 0))
                    ? []
                    : LocalData.filterNumberArrays(this.modalTopFilters.categories)!!;
            } else {
                return (this.$kviCart.categories.length === 0 || (this.$kviCart.categories.length && this.$kviCart.categories[0] === 0))
                    ? []
                    : LocalData.filterNumberArrays(this.$kviCart.categories)!!;
            }
        })();

        const selectSubcategories: number[] = (() => {
            if (isForAddProductsModal) {
                return (this.modalTopFilters.subcategories.length === 0 || (this.modalTopFilters.subcategories.length && this.modalTopFilters.subcategories[0] === 0))
                    ? []
                    : LocalData.filterNumberArrays(this.modalTopFilters.subcategories)!!;
            } else {
                return (this.$kviCart.subcategories.length === 0 || (this.$kviCart.subcategories.length && this.$kviCart.subcategories[0] === 0))
                    ? []
                    : LocalData.filterNumberArrays(this.$kviCart.subcategories)!!;
            }
        })();

        const selectSegments: number[] = (this.$kviCart.productSegments.length === 0 || (this.$kviCart.productSegments.length && this.$kviCart.productSegments[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$kviCart.productSegments)!!;
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });

        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });

        if (isForAddProductsModal) {
            if (this.addProductsToCartTableFilterValues.group !== -1) {
                selectGroups.push(this.addProductsToCartTableFilterValues.group);
            }

            if (this.addProductsToCartTableFilterValues.category !== -1) {
                selectCategories.push(this.addProductsToCartTableFilterValues.category);
            }

            if (this.addProductsToCartTableFilterValues.subcategory !== -1) {
                selectSubcategories.push(this.addProductsToCartTableFilterValues.subcategory);
            }
        } else {
            if (this.cartProductsTableFilterValues.group !== -1) {
                selectGroups.push(this.cartProductsTableFilterValues.group);
            }

            if (this.cartProductsTableFilterValues.category !== -1) {
                selectCategories.push(this.cartProductsTableFilterValues.category);
            }

            if (this.cartProductsTableFilterValues.subcategory !== -1) {
                selectSubcategories.push(this.cartProductsTableFilterValues.subcategory);
            }
        }
        /* сейчас значение selectFilterProductSegment нигде не меняется, поэтому оно всегда остаётся дефолтным = -1,
          если нужно будет использовать, то нужно поменять this.selectFilterProductSegment на this.cartProductsTableFilterValues.productSegments
          (чтобы применялись именно значения из фильтрации таблицы "список товаров корзины") */
        if(this.selectFilterProductSegment != -1) {
          selectSegments.push(this.selectFilterProductSegment)
        }
        return [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments, ctm, priceSegments];
    }

    kviRecommendsSelectData(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.$packageKviRecommends.seasonSelected.length === 0 || (this.$packageKviRecommends.seasonSelected.length === 1 && this.$packageKviRecommends.seasonSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packageKviRecommends.seasonSelected)!!;
        const selectRegions: number[] = (this.$packageKviRecommends.regionSelected.length === 0 || (this.$packageKviRecommends.regionSelected.length && this.$packageKviRecommends.regionSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packageKviRecommends.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$packageKviRecommends.buyerSegmentsList.length === 0 || (this.$packageKviRecommends.buyerSegmentsList.length && this.$packageKviRecommends.buyerSegmentsList[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packageKviRecommends.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.$packageKviRecommends.formatSelected.length === 0 || (this.$packageKviRecommends.formatSelected.length && this.$packageKviRecommends.formatSelected[0] === 0))
                ? []
                // tslint:disable-next-line: no-non-null-assertion
                : LocalData.filterNumberArrays(this.$packageKviRecommends.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    tryFindParams(dontRefreshSkus: boolean = false) {
        this.serverConfigTimeout = null;
        const [selectRegions] = this.selectData();
        const clusterSelected = this.$kviCart.clusterSelected.length > 0 ? this.$kviCart.clusterSelected[0] : null;
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$kviCart.selectMarket.id;
        findParams.category = null;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.storeCluster = clusterSelected;
        findParams.storeRegionValues = selectRegions;
        findParams.groupsOfProduct = null;
        findParams.categories = null;
        findParams.storeFormat = this.$kviCart.formatSelected;
        findParams.groupOfProduct = null;
        findParams.category = null;
// tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = null;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = null
        findParams.kviCartId = this.$kviCart.selectKviCart.id;
        findParams.downloadParamsWithSubcategory = this.$kviCart.downloadParamsWithSubcategory;
        this.loadingConfigs = true;
        this.loadKviCartParams(findParams)
            .then(async (r) => {
                this.resetIndividualConfigs()
                await this.loadKviCartIndividual(findParams)
                })
                .finally(() => {
                    this.saveKviShoppingCart();
                    this.loadingConfigs = false
                    this.refreshSkuList()

                    if (!dontRefreshSkus) {
                        this.refreshSkuTableInPanel();
                    }
                })
                .catch((e) => {
                    this.loadingConfigs = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('kviCarts.messages.errorLoadCalcParams') as string);
                })
    }

    getCalcIndividualFilters(): IndividualConfigCmd<CalcIndividualConfigMap> {
        const [selectRegions] = this.selectData();
        const saveParams = new IndividualConfigCmd<CalcIndividualConfigMap>();
        saveParams.kviCartId = this.$kviCart.selectKviCart.id;
        saveParams.tradingId = this.$kviCart.selectMarket.id;
        saveParams.category = null;
        // tslint:disable-next-line: no-non-null-assertion
        saveParams.storeCluster = this.$kviCart.clusterSelected.length === 0 ? null : this.$kviCart.clusterSelected[0];
        saveParams.storeRegionValues = selectRegions;
        saveParams.groupsOfProduct = null;
        saveParams.categories = null;
        saveParams.storeFormat = this.$kviCart.formatSelected;
        saveParams.groupOfProduct = this.$kviCart.groupOfProduct;
        saveParams.category = this.$kviCart.categoryOfProduct;
// tslint:disable-next-line: no-non-null-assertion
        saveParams.subcategories = null;
        // tslint:disable-next-line: no-non-null-assertion
        saveParams.productSegments = null;
        const individualConfigsObj = Object.create(null);
        // tslint:disable-next-line: forin
        for (const key in this.$kviCart.individualCommonParams) {
            const value = this.$kviCart.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }
        saveParams.individualConfigs = individualConfigsObj;
        saveParams.productRangesAndInternalCodes = this.productRangesArray;
        return saveParams
    }

    saveIndividualConfigs() {
        const saveParams = this.getCalcIndividualFilters()
        this.httpSaveKviCartIndividualConfig(saveParams)
                .then((r) => {
                    this.showInfo(this.$t('kviCarts.messages.individualParamsSaved') as string);
                    this.refreshSkuList();
                })
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorSaveIndividualParams') as string);
                })
    }

    saveIndividualConfigsInSkuPanel() {
        const saveParams = this.getCalcIndividualFilters()
        this.isSaveIndividualConfigsLoading = true;
        this.httpSaveBaseIndividualConfig(saveParams)
                .then((r) => {
                    this.showInfo(this.$t('kviCarts.messages.individualParamsSaved') as string);
                    this.refreshSkuTableInPanel();
                })
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorSaveIndividualParams') as string);
                })
                .finally(() => {
                    this.isSaveIndividualConfigsLoading = false;
                })
    }

    initTask() {
        if (this.$kviCart.selectMarket.id === -1) {
            return;
        }
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);

        this.$kviCart.groupOfProduct = null;
        this.$kviCart.categoryOfProduct = null;
        this.$kviCart.subcategory = null;
        this.$kviCart.segment = null;
        //для окна добавления в корзину
        this.$kviCart.groupsOfProduct = [];
        this.$kviCart.categories = [];
        this.$kviCart.subcategories = [];
        this.modalTopFilters.groupsOfProduct = [];
        this.modalTopFilters.categories = [];
        this.modalTopFilters.subcategories = [];
        this.$kviCart.formatSelected = null;
        this.$kviCart.clusterSelected = [];
        this.$kviCart.regionSelected = [];
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.groupsOfProduct = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.clusterOptions = [];
        const self = this;
        self.getFormatInfo();
        self.getRegionInfo();
        self.getGroupInfo();
        self.getCategoryInfo();
        self.getSubcategoryInfo();
        self.getSegmentInfo();
        self.getClusterInfo();
    }

    initKviRecommendsTask() {
        if (this.$packageKviRecommends.selectMarket.id === -1) {
            return;
        }
        (this.$refs.kviRecommendsGroupSelectedRef as any).toggleLoading(true);
        (this.$refs.updateKviRecommendsRegionsRef as any).toggleLoading(true);
        (this.$refs.updateKviRecommendsSeasonsRef as any).toggleLoading(true);
        (this.$refs.updateKviRecommendsBuyerSegmentsRef as any).toggleLoading(true);
        (this.$refs.kviRecommendsFormatSelectedRef as any).toggleLoading(true);
        (this.$refs.kviRecommendsClusterSelectedRef as any).toggleLoading(true);
        (this.$refs.kviRecommendsGroupOfProductRef as any).toggleLoading(true);
        (this.$refs.kviRecommendsSubcategoriesRef as any).toggleLoading(true);
        (this.$refs.kviRecommendsProductSegmentsRef as any).toggleLoading(true);

        this.$packageKviRecommends.categoriesOfProduct = [];
        this.$packageKviRecommends.clusterSelected = [];
        this.$packageKviRecommends.formatSelected = [];
        this.$packageKviRecommends.groupsOfProduct = [];
        this.$packageKviRecommends.subcategories = [];
        this.$packageKviRecommends.productSegments = [];
        this.taskInfoPackageKviRecommends.storeFormatOptions = [];
        this.taskInfoPackageKviRecommends.storeRegionOptions = [];
        this.taskInfoPackageKviRecommends.buyerSegmentOptions = [];
        this.taskInfoPackageKviRecommends.categoryOptions = [];
        this.taskInfoPackageKviRecommends.clusterOptions = [];
        this.taskInfoPackageKviRecommends.psegemnts = [];
        this.taskInfoPackageKviRecommends.subcategories = [];
        this.taskInfoPackageKviRecommends.groupsOfProduct = [{value: null, label: this.$t('shared.boolFilter.all') as string}];
        const self = this;
        this.getKviRecommendsCategoryInfo(() => {
            self.loadKviRecommendsProductsGroup();
            self.getKviRecommendsRegionInfo();
            self.getKviRecommendsFormatInfo();
            self.getKviRecommendsBuyerSegment();
            self.getKviRecommendsClusterInfo();
            self.loadKviRecommendsProductsSubcategories();
            self.loadKviRecommendsProductSegments();
        });
    }

    downloadKviRecommendsActiveParams() {
        if (this.$packageKviRecommends.selectMarket.id !== -1) {
            const self = this;
            (this.$refs.kviRecommendsGroupSelectedRef as any).toggleLoading(true);
            (this.$refs.updateKviRecommendsRegionsRef as any).toggleLoading(true);
            (this.$refs.updateKviRecommendsSeasonsRef as any).toggleLoading(true);
            (this.$refs.updateKviRecommendsBuyerSegmentsRef as any).toggleLoading(true);
            (this.$refs.kviRecommendsFormatSelectedRef as any).toggleLoading(true);
            (this.$refs.kviRecommendsClusterSelectedRef as any).toggleLoading(true);
            (this.$refs.kviRecommendsGroupOfProductRef as any).toggleLoading(true);
            (this.$refs.kviRecommendsSubcategoriesRef as any).toggleLoading(true);
            (this.$refs.kviRecommendsProductSegmentsRef as any).toggleLoading(true);
            this.getKviRecommendsCategoryInfo();
            self.getKviRecommendsRegionInfo();
            self.getKviRecommendsFormatInfo();
            self.getKviRecommendsBuyerSegment();
            self.getKviRecommendsClusterInfo();
            self.loadKviRecommendsProductsGroup();
            self.loadKviRecommendsProductsSubcategories();
            self.loadKviRecommendsProductSegments();
        }
    }

    getKviRecommendsCategoryInfo(cb: any = null) {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.kviRecommendsGroupSelectedRef as any).toggleLoading(false);
                        (this.$refs.updateKviRecommendsSeasonsRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfoPackageKviRecommends.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoPackageKviRecommends.categoryOptions.unshift();
                    if (typeof cb === 'function') {
                        cb();
                    }
                })
                .catch((e) => {
                })
    }

    getRegionInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateRegionsRef as any).toggleLoading(false);

                    }, 500);

                    this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    getKviRecommendsRegionInfo() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateKviRecommendsRegionsRef as any).toggleLoading(false);

                    }, 500);

                    this.taskInfoPackageKviRecommends.storeRegionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    getSegmentPriceInfo() {
        const filter = this.getSkuFilter()
        this.httpGetMinMaxPriceSegmentForKviCarts(filter)
                .then((data) => {
                    const filterData = data.data;
                    this.segmentPriceOptions = filterData.map((i) => {
                        return {value: i, label: i.name}
                    });
                })
                .catch((e) => {
                })
    }

    getProductSegmentIdAndName() {
        if (this.$kviCart.selectMarket.id === -1) {
            return;
        }
        const filter = this.getSkuFilter()
        filter.tagType = TaskInfoFilterType.p_segemnt
        filter.categoryFilterInSkuList = this.addProductsToCartTableFilterValues.category;
        filter.subcategoryFilterInSkuList = this.addProductsToCartTableFilterValues.subcategory;
        filter.groupsOfProduct = null
        filter.categories = []
        filter.storeFormat = null
        const subcategoryFilter = filter.categoryFilterInSkuList === -1 ? [] : [filter.subcategoryFilterInSkuList];
        this.httpGetProductSegmentIdAndName( {...filter, subcategories: subcategoryFilter})
                .then((data) => {
                    const filterData = data.data;
                    this.productSegmentIdAndNameOptions = filterData.map((i) => {
                        return {value: i, label: i.segmentName}
                        })
                        .filter(item => this.cartProductSegments.includes(item.label));
                })
                .catch((e) => {
                })
    }

    getAllGroupsIdAndNameInLastFile(): Promise<ProductTag[]>  {
        const filter = this.getCompetitorsFilter(true);

        filter.tagType = TaskInfoFilterType.group
        filter.categoryFilterInSkuList = this.addProductsToCartTableFilterValues.category;
        filter.subcategoryFilterInSkuList = this.addProductsToCartTableFilterValues.subcategory;
        filter.category = -1

        return new Promise((resolve, _) => {
            this.httpGetProductTagsIdAndNameInLastAssortmentFile(filter)
                .then((data) => {
                    resolve(data.data);
                })
                .catch(() => {
                    resolve([]);
                });
        });
    }

    getAllCategoriesIdAndNameInLastFile(): Promise<ProductTag[]> {
        const filter = this.getCompetitorsFilter(true);

        filter.tagType = TaskInfoFilterType.category
        filter.groupFilterInSkuList = this.addProductsToCartTableFilterValues.group;
        filter.subcategoryFilterInSkuList = this.addProductsToCartTableFilterValues.subcategory;
        filter.category = -1

        return new Promise((resolve, _) => {
            this.httpGetProductTagsIdAndNameInLastAssortmentFile(filter)
                .then((data) => {
                    resolve(data.data);
                })
                .catch(() => {
                    resolve([]);
                });
        });
    }

    getAllSubCategoriesIdAndNameInLastFile(): Promise<ProductTag[]>  {
        const filter = this.getCompetitorsFilter(true);

        filter.tagType = TaskInfoFilterType.subcategory
        filter.groupFilterInSkuList = this.addProductsToCartTableFilterValues.group;
        filter.categoryFilterInSkuList = this.addProductsToCartTableFilterValues.category;
        filter.category = -1

        return new Promise((resolve, _) => {
            this.httpGetProductTagsIdAndNameInLastAssortmentFile(filter)
                .then((data) => {
                    resolve(data.data);
                })
                .catch(() => {
                    resolve([]);
                });
        });
    }

    getSkuKeysAndAttributes() {
        if (this.$kviCart.selectMarket.id === -1) {
            return;
        }
        const filter = this.getSkuFilter()
        filter.groupsOfProduct = []
        filter.categories = []
        filter.subcategories = []
        filter.priceSegments = []
        filter.storeFormat = null
        filter.storeCluster = null
        filter.categoryFilterInSkuList = this.addProductsToCartTableFilterValues.category;
        filter.subcategoryFilterInSkuList = this.addProductsToCartTableFilterValues.subcategory;
        filter.segmentFilterInSkuList = this.selectFilterProductSegment
        const subcategoryFilter = filter.categoryFilterInSkuList === -1 ? [] : [filter.subcategoryFilterInSkuList];
        const segmentsFilter = filter.segmentFilterInSkuList === -1 ? [] : [filter.segmentFilterInSkuList];
        this.httpGetSkuKeysAndAttributes({...filter, subcategories: subcategoryFilter, productSegments: segmentsFilter})
                .then((result) => {
                    this.keyCharacteristicOneOptions = result.data.keyProducts1.map((item) => {
                        return {value: item, label: item};
                    });
                    this.keyCharacteristicTwoOptions = result.data.keyProducts2.map((item) => {
                        return {value: item, label: item};
                    });
                    this.recipeAttributesOptions = result.data.recipeAttributes.map((item) => {
                        return {value: item, label: item};
                    });
                    this.treatmentAttributesOptions = result.data.treatmentAttributes.map((item) => {
                        return {value: item, label: item.toString()};
                    });
                })
                .catch((e) => {
                })
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.formatSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });

                  this.taskInfo.storeFormatOptions = [{
                    value: null,
                    label: this.$t('shared.boolFilter.all') as string,
                  }, ...this.taskInfo.storeFormatOptions];
                })
                .catch((e) => {
                });
    }

    getGroupInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                // setTimeout(() => {
                //     (this.$refs.updateGroupRef as any).toggleLoading(false);
                // }, 500);

                this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }


    getCategoryInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                // setTimeout(() => {
                //     (this.$refs.updateCategoryRef as any).toggleLoading(false);
                // }, 500);

                this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getSubcategoryInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                // setTimeout(() => {
                //     (this.$refs.updateSubcategoryRef as any).toggleLoading(false);
                // }, 500);

                this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getSegmentInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                // setTimeout(() => {
                //     (this.$refs.updateSegmentRef as any).toggleLoading(false);
                // }, 500);

                this.taskInfo.psegemnts = filterData.psegments.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getKviRecommendsFormatInfo() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.kviRecommendsFormatSelectedRef as any).toggleLoading(false);
                    }, 500);
                    this.taskInfoPackageKviRecommends.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });

                })
                .catch((e) => {
                });
    }

    getKviRecommendsBuyerSegment() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.buyer))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.updateKviRecommendsBuyerSegmentsRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfoPackageKviRecommends.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                        return {value: i.id, label: i.name};
                    });

                })
                .catch((e) => {
                });
    }

    getClusterInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                  this.taskInfo.clusterOptions = [{
                    value: null,
                    label: this.$t('shared.boolFilter.all') as string,
                  }, ...this.taskInfo.clusterOptions];
                })
                .catch((e) => {
                });
    }

    getKviRecommendsClusterInfo() {
        this.httpGetProductInfo(this.getKviRecommendsTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.kviRecommendsClusterSelectedRef as any).toggleLoading(false);
                    }, 500);

                    this.taskInfoPackageKviRecommends.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name};
                    });
                })
                .catch((e) => {
                });
    }

    prepareIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            if (config.kviStrategy.value) {
                prepared.kviStrategy = config.kviStrategy.value
            }
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit !== null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('marginalProfitKvi' in config && typeof config.marginalProfitKvi !== 'undefined' && config.marginalProfitKvi !== null) {
            prepared.marginalProfitKvi = config.marginalProfitKvi;
        }

        if ('marginalProfitCompetitors' in config && typeof config.marginalProfitCompetitors !== 'undefined' && config.marginalProfitCompetitors !== null) {
            prepared.marginalProfitCompetitors = config.marginalProfitCompetitors;
        }

        if ('priceChangeLimit' in config && typeof config.priceChangeLimit !== 'undefined' && config.priceChangeLimit !== null) {
            prepared.priceChangeLimit = config.priceChangeLimit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit !== null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams !== null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit !== null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        if ('competitorNames' in config && typeof config.competitorNames !== 'undefined' && config.competitorNames !== null) {
            prepared.competitorNames = config.competitorNames;
        }

        return prepared;
    }

    async calcPackageKviCarts() {
        if (!await this.checkCalculationPreconditions()) {
            return;
        }

        this.showInfo(this.$t('kviCarts.messages.calcStarted') as string);
        const config = this.getPackageCalcConfig()
        this.saveKviShoppingCart();
        this.httpPostAddPackageKviCartTask(config)
                .then((r) => {
                            this.$log.debug('Create kvi cart package task', r.data);
                        },
                )
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorStartCalc') as string);
                    this.$log.error('Error occurred on creating kvi cart calc', e)
                });
    }

    hideSkuPanel() {
        this.clearFilters();
    }

    async save() {
        const filters = this.getKviCartFilter();

        this.isSaveParamsButtonLoading = true;

        this.httpSaveKviCartFilter(filters)
                .then((r) => {
                    this.$log.debug('Параметры сохранены', r.data);
                    this.showInfo(this.$t('kviCarts.messages.paramsSaved') as string);
                }).catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorSaveCalcParams') as string);
                }).finally(() => {
                    this.isSaveParamsButtonLoading = false;
                });
    }

    checkSkuButtonWithCalc() {
        if (!this.skuListWithCalculating && this.isFiltersChanged === 0) {
            this.isFiltersChanged = 1;
        }
        this.skuListWithCalculating = true;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = true;
        this.calcSkuActualProfitButtonDisabled = true;
    }

    checkSkuButtonWithoutCalc() {
        if (this.skuListWithCalculating && this.isFiltersChanged === 0) {
            this.isFiltersChanged = 1;
        }
        this.skuListWithCalculating = false;
    }

    loadSkuWithoutCalc() {
        this.skuListWithCalculating = false;
        this.needLoadSkuList = true;
        this.fetchSkuList(true);
    }

    loadSkuWithoutCalcModal(isNeedFetchFilterOptions: boolean = false) {
      this.skuListWithCalculating = false;
      this.needLoadSkuList = true;
      this.fetchFullSkuList(isNeedFetchFilterOptions, 1);
    }

    reloadSkuList() {
        this.isFiltersChanged = 1;
        this.needLoadSkuList = false;
    }

    loadSkuWithCalcInPanel() {
        this.isLoadSkuButtonLoading = true;
        this.skuListWithCalculating = true;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = true;
        this.calcSkuActualProfitButtonDisabled = true;
        this.refreshSkuTableInPanel();

        // Set loading to false after the timeout in refreshSkuTableInPanel completes
        setTimeout(() => {
            this.isLoadSkuButtonLoading = false;
        }, 500);
    }

    loadSkuWithCalc() {
        this.skuListWithCalculating = true;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = true;
        this.calcSkuActualProfitButtonDisabled = true;
        this.refreshSkuList();
    }

  fetchFullSkuList(isNeedFetchFilterOptions: boolean = false, currentPage?: number) {
    if (this.$kviCart.selectMarket.id === -1) {
      this.skuListAddProductsToCartModal = [];
      return;
    }
    // if (this.isFiltersChanged === 0 && this.lastPage === ctx.currentPage) {
    //     callback(this.skuList);
    //     return;
    // }

    if (currentPage) {
        this.paginationInModal.current = currentPage;
    }

    const filter = this.getSkuFilter(true);

    filter.skuFilter = this.skuFilterAddProductModal
    filter.kviCartIdFilter = -1
    filter.kviCartNameFilter = undefined
    //Временное решение, чтобы метод загружающий товары KVI загружал всё как в списке товаров
    filter.kvi = 2
    // filter.storeFormat = null
    const offset = (this.paginationInModal.current - 1) * this.paginationInModal.pageSize;

    this.isAddProductsToCartTableLoading = true;

    this.httpGetKviCartSkuList(filter, this.paginationInModal.pageSize, offset)
        .then((r) => {
              this.skuListAddProductsToCartModal = r.data.content;
              this.cartInternalCodes = this.skuListAddProductsToCartModal.map((value) => value.internalCode);
              const pagination = { ...this.paginationInModal };
              pagination.total = this.getTotalCount(r.data.totalElements, r.data.content.length, this.paginationInModal.pageSize, this.paginationInModal.current);
              this.paginationInModal = pagination;
              this.skuListTotalRows = this.getTotalCount(r.data.totalElements, r.data.content.length, this.paginationInModal.pageSize, this.paginationInModal.current);
              this.isFiltersChanged = 0;

            if (isNeedFetchFilterOptions) {
                Promise.all([
                    this.getAllGroupsIdAndNameInLastFile(),
                    this.getAllCategoriesIdAndNameInLastFile(),
                    this.getAllSubCategoriesIdAndNameInLastFile(),
                ]).then((data) => {
                    this.addProductsToCartTableFilterOptions = {
                        groups: data[0].map((option) => ({ value: option.id, label: option.name })),
                        categories: data[1].map((option) => ({ value: option.id, label: option.name })),
                        subcategories: data[2].map((option) => ({ value: option.id, label: option.name })),
                    }
                }).catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorLoadDictionaries') as string + ': ' + String(e));
                });
            }
        })
        .catch((e) => {
          this.isFiltersChanged = 0;
          this.skuListAddProductsToCartModal = [];
        })
        .finally(() => {
            this.isAddProductsToCartTableLoading = false;
        });

    // this.getAllGroupsIdAndNameInLastFile();
    // this.getAllCategoriesIdAndNameInLastFile();
    // this.getAllSubCategoriesIdAndNameInLastFile();

    // if (this.skuListWithCalculating && this.segmentPriceOptions.length === 0) {
    //   this.getSegmentPriceInfo();
    // }

    // SP-49715 временно отключили, требуется поправить фильтр
    // this.getSkuKeysAndAttributes();
    // this.getProductSegmentIdAndName();

    // this.httpGetProductRangeListByFilters(filter)
    //     .then((r) => {
    //           this.productLineOptions = r.data.map((i) => {
    //             return {value: i, label: i}
    //           });
    //           this.productLineOptionsForFilter = r.data.map((i) => {
    //             return {value: i, label: i}
    //           });
    //           this.productLineOptions.unshift({value: '', label: this.$t('kviCart.labels.empty') as string});
    //           this.productLineOptionsForFilter.unshift({value: 'all', label: this.$t('kviCart.labels.all2') as string}, {value: '', label: this.$t('kviCart.labels.empty2') as string});
    //         },
    //     )
    //     .catch((ex) => {
    //       this.showError(this.$t('kviCart.errors.loadProductRanges') as string)
    //     });
  }

    fetchSkuList(isNeedFetchFilterOptions: boolean = false, currentPage?: number) {
        if (this.$kviCart.selectKviCart.id === -1) {
            this.skuList = [];
            return;
        }

        if (currentPage) {
            this.pagination.current = currentPage;
        }
        // if (this.isFiltersChanged === 0 && this.lastPage === ctx.currentPage) {
        //     callback(this.skuList);
        //     return;
        // }

        const filter = this.getSkuFilter()
        filter.groupsOfProduct = [this.cartProductsTableFilterValues.group];
        filter.categories = [this.cartProductsTableFilterValues.category];
        filter.subcategories = [this.cartProductsTableFilterValues.subcategory];
        filter.storeFormat = null;
        filter.storeFormats = this.cartProductsTableFilterValues.formats;
        filter.storeRegionValues = this.cartProductsTableFilterValues.regions;
        filter.storeCluster = null;
        filter.storeClusters = this.cartProductsTableFilterValues.clusters;
        filter.productSegments = this.cartProductsTableFilterValues.productSegments;

        const offset = (this.pagination.current - 1) * this.pagination.pageSize;
        this.isFetchSkuListDownload = true;
        this.httpGetKviCartSkuList(filter, this.pagination.pageSize, offset)
            .then(async (r) => {
                 this.skuList = r.data.content;

                 if (Object.keys(this.competitorsNamesObj).length) {
                     this.competitorsNamesObj = {};
                 }

                 r.data.content.forEach(product => {
                     if (product.competitorNames && product.competitorNames.length) {
                         this.competitorsNamesObj[product.internalCode] = product.competitorNames;
                     }
                 })

                this.cartInternalCodes = this.skuList.map((value) => value.internalCode);
                   this.cartGroups =  [...new Set(this.skuList.map((value) => value.productGroup))];
                   this.cartCategories = [...new Set(this.skuList.map((value) => value.categoryName))];
                   this.cartSubcategories = [...new Set(this.skuList.map((value) => value.subcategory))];
                   this.cartProductSegments = [...new Set(this.skuList.map((value) => value.productSegmentName))];
                   const pagination = { ...this.pagination };
                   pagination.total = this.getTotalCount(r.data.totalElements, r.data.content.length, this.pagination.pageSize, this.pagination.current);
                   this.pagination = pagination;
                   this.skuListTotalRows = this.getTotalCount(r.data.totalElements, r.data.content.length, this.pagination.pageSize, this.pagination.current);
                   this.isFetchSkuListDownload = false;
                   this.isFiltersChanged = 0;

                   this.tryFindParams(true);

                    if (isNeedFetchFilterOptions) {
                        this.httpGetCartProductsTableFilterOptions(this.$kviCart.selectMarket.id, this.$kviCart.selectKviCart.id, {})
                            .then(({ data } : { data: AssortmentDirectoryFilterOptions }) => {
                                this.cartProductsTableFilterOptions = {
                                    groups: data.groups.map((option) => ({ value: option.id, label: option.name })),
                                    categories: data.categories.map((option) => ({ value: option.id, label: option.name })),
                                    subcategories: data.subcategories.map((option) => ({ value: option.id, label: option.name })),
                                    formats: data.storeFormats.map((option) => ({ value: option.id, label: option.name })),
                                    regions: data.storeRegions.map((option) => ({ value: option.id, label: option.name })),
                                    clusters: data.storeClusters.map((option) => ({ value: option.id, label: option.name })),
                                    productSegments: data.segments!.map((option) => ({ value: option.id, label: option.name })),
                                };
                            });
                    }
                 })
            .catch((e) => {
               this.isFetchSkuListDownload = false;
               this.isFiltersChanged = 0;
               this.skuList = [];
             });

        // if (this.skuListWithCalculating && this.segmentPriceOptions.length === 0) {
        //     this.getSegmentPriceInfo();
        // }
      // SP-49715 временно отключили, требуется поправить фильтр
      //   this.getProductSegmentIdAndName();
      //   this.getSkuKeysAndAttributes();

        // this.httpGetProductRangeListByFilters(filter)
        //         .then((r) => {
        //                     this.productLineOptions = r.data.map((i) => {
        //                         return {value: i, label: i}
        //                     });
        //                     this.productLineOptionsForFilter = r.data.map((i) => {
        //                         return {value: i, label: i}
        //                     });
        //                     this.productLineOptions.unshift({value: '', label: this.$t('kviCart.labels.empty3') as string});
        //                     this.productLineOptionsForFilter.unshift({value: 'all', label: this.$t('kviCart.labels.all3') as string}, {value: '', label: this.$t('kviCart.labels.empty4') as string});
        //                 },
        //         )
        //         .catch((ex) => {
        //             this.showError(this.$t('kviCart.errors.loadProductRanges2') as string)
        //         });
    }

    resetCartProductsTableFilterOptions() {
        this.cartProductsTableFilterOptions = {
            groups: [],
            categories: [],
            subcategories: [],
            formats: [],
            regions: [],
            clusters: [],
            productSegments: [],
        };
    }

    resetCartProductsTableFilterValues() {
        this.cartProductsTableFilterValues = {
            group: this.defaultFilterValue.value,
            category: this.defaultFilterValue.value,
            subcategory: this.defaultFilterValue.value,
            formats: [],
            regions: [],
            clusters: [],
            productSegments: [],
        }
    }

    resetAddProductsToCartTableFilterOptions() {
        this.addProductsToCartTableFilterOptions = {
            groups: [],
            categories: [],
            subcategories: [],
        };
    }

    resetAddProductsToCartTableFilterValues() {
        this.addProductsToCartTableFilterValues = {
            group: this.defaultFilterValue.value,
            category: this.defaultFilterValue.value,
            subcategory: this.defaultFilterValue.value,
        }
    }

    get isCartProductsTableResetFiltersBtnDisabled(): boolean {
        const filters = this.cartProductsTableFilterValues;
        const { value: defaultValue } = this.defaultFilterValue;

        const hasDefaultValueChanged =
            filters.group !== defaultValue ||
            filters.category !== defaultValue ||
            filters.subcategory !== defaultValue ||
            this.selectKVI !== defaultValue ||
            this.selectKVIRecommends !== defaultValue ||
            this.selectCTM !== this.defaultCtmFilterValue.value ||
            this.selectProductLine !== 'all';

        if (hasDefaultValueChanged) return false;

        const arrayChecks = [
            filters.formats,
            filters.regions,
            filters.clusters,
            filters.productSegments,
            this.selectKeyCharacteristicOne,
            this.selectKeyCharacteristicTwo,
            this.selectRecipeAttributes,
            this.selectTreatmentAttributes,
            this.selectSegmentPrice
        ];

        return !arrayChecks.some(arr => !!arr.length);
    }

    handleCartProductsTableResetFilters() {
        this.resetCartProductsTableFilterValues();

        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = this.defaultCtmFilterValue.value;
        this.selectProductLine = 'all';
        this.selectSegmentPrice = [];

        this.fetchSkuList(true, 1);
    }

    getTotalCount(totalElements: number, contentLength: number, pageSize: number, pageNumber: number): number {
        if (pageNumber === 1) {
            if (contentLength < pageSize) {
                return contentLength;
            } else {
                return totalElements;
            }
        } else {
            if (contentLength < pageSize) {
                return pageSize * (pageNumber - 1) + contentLength;
            } else {
                return totalElements;
            }
        }
    }

    async checkCalculationPreconditions(): Promise<boolean> {
        this.isCalculateButtonLoading = true;

        const filter = this.getSkuFilter();
        filter.groupsOfProduct = [this.cartProductsTableFilterValues.group]
        filter.categories = [this.cartProductsTableFilterValues.category]
        filter.subcategories = [this.cartProductsTableFilterValues.subcategory]

      //если список SKU отфильтрован по выбранным сегментам, проверка не учтёт выбор
        filter.priceSegments = [];
        try {
          const flag = await this.httpHasMatchingFilterItems(filter)
              .then(r => r.data)
              .catch(e => {
                this.showError(this.$t('kviCarts.messages.errorCheckFilter') as string);
                return false;
              })

          if (!flag) {
            this.showError(this.$t('kviCarts.messages.errorNoProductsInFilter') as string);
            return false
          }

          return await this.httpGetKviCartSkuList(filter, 1, 0)
              .then(r => {
                    if(!r.data.content.length) {
                      this.showError(this.$t('kviCarts.messages.errorNoProductsInCart') as string);
                    }
                    return !!r.data.content.length;
                  },
              )
              .catch(() => {
                this.showError(this.$t('kviCarts.messages.errorCheckCartProducts') as string);
                return false;
              })
        }
        finally {
          this.isCalculateButtonLoading = false;
        }
    }

    async downloadAllSku() {
        if (this.$kviCart.selectMarket.id === -1) {
            return;
        }

        const filter = this.getSkuFilter()
        await this.httpGetKviCartAllSku(filter)
                .then((r) => {
                            this.skuListWithAllProducts = r.data;
                        },
                )
                .catch((e) => {
                });
    }

    sortSkuListBySKU() {
        if (this.sortBySKU === -1 || this.sortBySKU === 1) {
            this.sortBySKU = 0;
        } else {
            this.sortBySKU = 1;
        }
        this.refreshSkuList();
    }

    onCompetitorsTableChange(pagination: any, filters: any, sorter: any) {

        Object.keys(filters).forEach((item) => {
            let key = item;

            if (key === 'subCategoryName') key = 'subcategoryName'
            if (key === 'productSegmentName') key = 'segmentName'
            if (key === 'segment') key = 'segmentPrice'
            if (key === 'kvi') key = 'KVI'
            if (key === 'ctm') key = 'CTM'

            key = key.charAt(0).toUpperCase() + key.slice(1);
            // @ts-ignore
            if (this[`select${key}ForDetailTable`]) this[`select${key}ForDetailTable`] = filters[item];
            // @ts-ignore
            else this[`select${key}sForDetailTable`] = filters[item]
        })
        this.paginationInCompetitors = { ...pagination }
        this.onHeadClicked(sorter.field).then(() => this.listCompetitors({}, () => {}));
    }

    onHeadClicked(key: string) {
        this.sortingField = null;
        const fieldDef = this.newCompetitorsTableFields.find((value, index) => value.dataIndex === key);
        switch (key) {
            case 'internalCode': {
                if (fieldDef !== undefined) {
                    this.sortByInternalCodeInCompetitorsTable(key)
                }
                break;
            }
            case 'storeFormat': {
                if (fieldDef !== undefined) {
                    this.sortByStoreFormatInCompetitorsTable(key)
                }
                break;
            }
            case 'storeRegion': {
                if (fieldDef !== undefined) {
                    this.sortByStoreRegionInCompetitorsTable(key)
                }
                break;
            }
            case 'skuName': {
                if (fieldDef !== undefined) {
                    this.sortBySkuNameInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorName': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorNameInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorPriority': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorPriorityInCompetitorsTable(key)
                }
                break;
            }
            case 'lastPrice': {
                if (fieldDef !== undefined) {
                    this.sortByLastPriceInCompetitorsTable(key)
                }
                break;
            }
            case 'promoPrice': {
                if (fieldDef !== undefined) {
                    this.sortByPromoPriceInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorPriceInCompetitorsTable(key)
                }
                break;
            }
            case 'delta': {
                if (fieldDef !== undefined) {
                    this.sortByDeltaInCompetitorsTable(key)
                }
                break;
            }
            case 'kvi': {
                if (fieldDef !== undefined) {
                    this.sortByKviInCompetitorsTable(key)
                }
                break;
            }
            case 'ctm': {
                if (fieldDef !== undefined) {
                    this.sortByCtmInCompetitorsTable(key)
                }
                break;
            }
            case 'dataIndexCharacteristicOfTheProductIsOne': {
                if (fieldDef !== undefined) {
                    this.sortByDataIndexCharacteristicOfTheProductIsOneInCompetitorsTable(key)
                }
                break;
            }
            case 'dataIndexCharacteristicOfTheProductIsTwo': {
                if (fieldDef !== undefined) {
                    this.sortByDataIndexCharacteristicOfTheProductIsTwoInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorDate': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorDateInCompetitorsTable(key)
                }
                break;
            }
        }

        return Promise.resolve();
    }

    resetAllSortingFields() {
        this.sortByInternalCode = -1
        this.sortByStoreFormat = -1;
        this.sortByStoreRegion = -1;
        this.sortBySkuName = -1;
        this.sortByCompetitorName = -1;
        this.sortByCompetitorPriority = -1;
        this.sortByLastPrice = -1;
        this.sortByPromoPrice = -1;
        this.sortByCompetitorPrice = -1;
        this.sortByDelta = -1;
        this.sortByKvi = -1;
        this.sortByDataIndexCharacteristicOfTheProductIsOne = -1;
        this.sortByDataIndexCharacteristicOfTheProductIsTwo = -1;
        this.sortByCompetitorDate = -1;
    }

    sortByInternalCodeInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByInternalCode
        this.resetAllSortingFields()
        const fieldValue = this.sortByInternalCode = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByStoreFormatInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByStoreFormat
        this.resetAllSortingFields()
        const fieldValue = this.sortByStoreFormat = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByStoreRegionInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByStoreRegion
        this.resetAllSortingFields()
        const fieldValue = this.sortByStoreRegion = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySkuNameInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortBySkuName
        this.resetAllSortingFields()
        const fieldValue = this.sortBySkuName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorNameInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorName
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorPriorityInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorPriority
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorPriority = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByLastPriceInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByLastPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByLastPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByPromoPriceInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByPromoPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByPromoPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorPriceInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDeltaInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByDelta
        this.resetAllSortingFields()
        const fieldValue = this.sortByDelta = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByKviInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByKvi
        this.resetAllSortingFields()
        const fieldValue = this.sortByKvi = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCtmInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCtm
        this.resetAllSortingFields()
        const fieldValue = this.sortByCtm = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDataIndexCharacteristicOfTheProductIsOneInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByDataIndexCharacteristicOfTheProductIsOne
        this.resetAllSortingFields()
        const fieldValue = this.sortByDataIndexCharacteristicOfTheProductIsOne = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDataIndexCharacteristicOfTheProductIsTwoInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByDataIndexCharacteristicOfTheProductIsTwo
        this.resetAllSortingFields()
        const fieldValue = this.sortByDataIndexCharacteristicOfTheProductIsTwo = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorDateInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorDate
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorDate = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortSkuListBySKUInTablePanel() {
        if (this.sortBySKU === -1 || this.sortBySKU === 1) {
            this.sortBySKU = 0;
        } else {
            this.sortBySKU = 1;
        }
        this.refreshSkuTableInPanel();
    }

    isPriceCategoryRecommends(sku: Sku): boolean {
        return sku.priceCategoryRecommendation;
    }

    isCartGeneratorRecommends(sku: Sku): boolean {
        return sku.cartGeneratorRecommendation;
    }

    isSelectedKvi(sku: Sku): boolean {
        return sku.kvi === 1;
    }

    isActiveSaveKviButton(): boolean {
        return this.productCodesForAddKvi.length === 0 && this.productCodesForDeleteKvi.length === 0;
    }

    setSelectedKvi(sku: Sku, selected: boolean) {
        if (selected) {
            if (sku.kvi !== 1) {
                this.productCodesForAddKvi.push(sku.internalCode);
            }
            const index = this.productCodesForDeleteKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForDeleteKvi.splice(index, 1);
            }
        } else {
            if (sku.kvi === 1) {
                this.productCodesForDeleteKvi.push(sku.internalCode);
            }
            const index = this.productCodesForAddKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForAddKvi.splice(index, 1);
            }
        }
    }

    getProductRange(productLine: string): string {
        const index = this.productLineOptions.findIndex((item) => {
            return item.value === productLine
        });

        if (index !== -1) {
            return this.productLineOptions[index].value
        } else {
            return ''
        }
    }

    inputOrDeleteProductRange(row: Sku, value: string) {
        const index = this.productRangesArray.findIndex((item) => {
            return item.internalCode === row.internalCode
        });

        const rangeAndCode: InternalCodeAndProductRange = {
            internalCode: row.internalCode,
            productRange: value,
        };

        if (index === -1) {
            this.productRangesArray.push(rangeAndCode)
        } else {
            this.productRangesArray.splice(index, 1)
            this.productRangesArray.push(rangeAndCode)
        }
    }

    saveKviParamsForSkuInPanel() {
        const filters = this.getFullCommonFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParam(filters)
                .then((r) => {
                    this.kviSaveProcess = false;
                    this.showInfo(this.$t('kviCarts.messages.kviSaved') as string);
                    this.productCodesForAddKvi = [];
                    this.productCodesForDeleteKvi = [];
                    this.refreshSkuTableInPanel();
                })
                .catch((e) => {
                    this.kviSaveProcess = false;
                    this.showError(this.$t('kviCarts.messages.errorSaveKvi') as string);
                    this.productCodesForAddKvi = [];
                    this.productCodesForDeleteKvi = [];
                });
    }

    clearFilters() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = {value: 'all', label: this.$t('shared.boolFilter.all') as string}.value;
        this.selectSegmentPrice = [];
        this.selectProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = {value: 'all', label: this.$t('shared.boolFilter.all') as string}.value;

        this.resetAddProductsToCartTableFilterValues();
        this.resetAddProductsToCartTableFilterOptions();

        this.resetCartProductsTableFilterOptions();
        this.resetCartProductsTableFilterValues();

        this.refreshSkuList()
    }

    clearFiltersInSkuTablePanel() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = {value: 'all', label: this.$t('shared.boolFilter.all') as string}.value;
        this.selectSegmentPrice = [];
        this.selectProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = {value: 'all', label: this.$t('shared.boolFilter.all') as string}.value;

        this.resetAddProductsToCartTableFilterValues();

        this.refreshSkuTableInPanel()
    }

    selectOrClearAllCompetitors() {
        if (this.$kviCart.competitorsCodes.length !== 0) {
            this.$kviCart.competitorsCodes = []
        } else {
            this.$kviCart.competitorsCodes = this.competitors.map((i) => {
                return i.internalCode;
            });
        }
    }

    calcButtonState(): boolean {
        if (this.$kviCart.selectMarket != null) {
            const state = this.paramsSum && this.paramsSumXYZ && this.calculationDepthValidate
                    && this.calculationDayValidate && this.priceIncreaseLimitValidate && this.competitorsPricesValidate
                    && this.marginalProfitValidate && this.highElasticityCheck && this.minProfitKVIValidate && this.competitorsMinProfitValidate
                    && this.periodPriceIncreaseLimitValidate && this.priceChangeLimitValidate && this.competitorPriceControlParameterPcValidate && this.marginalProfitDeclinePcValidate;
            return !state;

        }
        return true;
    }

    listCompetitors(ctx: any, callback: (items: any[]) => void) {
        if (this.$kviCart.selectMarket.id === -1) {
            callback([]);
            return;
        }
        const competitorFilter = this.getCompetitorsFilter();
        competitorFilter.category = -1
        const offset = (this.paginationInCompetitors.current - 1) * this.paginationInCompetitors.pageSize;
        this.isLoadCompetitorPrices = true;
        this.httpLoadCompetitorsPrice(competitorFilter, this.paginationInCompetitors.pageSize, offset)
                .then((response) => {
                    this.onLoadCompetitors(response.data.content);
                    const pagination = { ...this.paginationInCompetitors };
                    pagination.total = response.data.totalElements;
                    this.paginationInCompetitors = pagination;
                    this.isLoadCompetitorPrices = false;
                })
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorLoadCompetitorPrices') as string);
                    this.isLoadCompetitorPrices = false;
                    callback([]);
                })
    }

    filterAll(): void {
        this.viewCompetitors = this.applyFilterByKey(this.selectedSkuNameFilter, 'skuName', this.competitors);
        this.viewCompetitors =  this.applyFilterByKey(this.selectedCompetitorsNameFilter, 'competitorName');
        this.viewCompetitors =  this.applyFilterByKey(this.selectedCompetitorsCodeFilter, 'competitorCode');
        this.viewCompetitors =  this.applyFilterByKey(this.selectedCompetitorsPriorityFilter, 'competitorPriority');
        this.viewCompetitors =  this.applyFilter(this.selectedLastPriceFilter,(competitor, searchLastPrice) => {
            return competitor.lastPrice.toString() == searchLastPrice;
        });
        this.viewCompetitors =  this.applyFilter(this.selectedCompetitorsPriceFilter, (competitor, searchPrice) => {
            return competitor.competitorPrice.toString() == searchPrice;
        });
        this.viewCompetitors =  this.applyFilter(this.selectedDeltaFilter, (competitor, searchDelta) => {
            return competitor.delta!!.toFixed(2) == searchDelta;
        });
        this.viewCompetitors =  this.applyFilterByKey(this.selectedKeyCharacteristicOneForCompetitors, 'keyCharacteristicOfTheProductIsOne');
        this.viewCompetitors =  this.applyFilterByKey(this.selectedKeyCharacteristicTwoForCompetitors, 'keyCharacteristicOfTheProductIsTwo');
        this.viewCompetitors =  this.applyFilter(this.selectedMonitoringDateFilter,  (competitor, searchDate) => {
            return new Date(competitor.competitorDate).toLocaleDateString() == searchDate;
        });
    }

    applyFilterByKey(searchValues: string[], field: keyof CompetitorsPriceRow, sourceValues: CompetitorsPriceRow[] = this.viewCompetitors) {
        return this.filterIfNotEmpty(sourceValues, searchValues, (v, s) => `${v[field]}` == s)
    }

    applyFilter(searchValues: string[],  equals: (v: CompetitorsPriceRow, s: string) => boolean) {
        return this.filterIfNotEmpty(this.viewCompetitors, searchValues, equals)
    }

    filterIfNotEmpty<V, S>(values: V[], searchValues: S[], equals: (v: V, s: S) => boolean) {
        return searchValues.length ? values.filter((value) => {
            return searchValues.filter((searchValue) => equals(value, searchValue)).length
        }) : values;
    }


    filterBySkuName(skuNames: string[]): void {
        this.selectedSkuNameFilter = skuNames.includes('Все') ? [] : skuNames;
        this.filterAll()
        this.setSelectAll("SkuName");
    }

    filterByCompetitorName(competitorNames: string[]): void {
        this.selectedCompetitorsNameFilter =  competitorNames.includes('Все') ? [] : competitorNames;
        this.filterAll();
        this.setSelectAll("CompetitorsName");
    }

    filterByCompetitorCode(competitorCodes: string[]): void {
        this.selectedCompetitorsCodeFilter =  competitorCodes.includes('Все') ? [] : competitorCodes;
        this.filterAll();
        this.setSelectAll("CompetitorsCode");
    }

    filterByCompetitorPriority(competitorPriorities: number[]): void {
        const priority = competitorPriorities.map((v) => v.toString());
        this.selectedCompetitorsPriorityFilter = priority.includes('Все') ? [] : priority;
        this.filterAll();
        this.setSelectAll("CompetitorPriority");
    }

    filterByLastPrice(lastPrices: number[]): void {
        this.selectedLastPriceFilter = lastPrices.map((v) => v.toString()).includes('Все') ? [] : lastPrices.map((v) => v.toString());
        this.filterAll();
        this.setSelectAll("LastPrice");
    }

    filterByCompetitorPrice(competitorPrices: number[]): void {
        this.selectedCompetitorsPriceFilter = competitorPrices.map((v) => v.toString()).includes('Все') ? [] : competitorPrices.map((v) => v.toString());
        this.filterAll();
        this.setSelectAll("CompetitorPrices");
    }

    filterByDelta(deltas: string[]): void {
        this.selectedDeltaFilter = deltas.includes('Все') ? [] : deltas;
        this.filterAll();
        this.setSelectAll("Delta");
    }

    filterByKvi(kvis: {value: number}): void {
        this.viewCompetitors = kvis.value == -1 ? this.viewCompetitors : this.viewCompetitors.filter((value) => kvis.value == value.kvi)
    }

    filterByCtm(cmts: {value: string}): void {
        this.viewCompetitors = cmts.value == 'all' ? this.viewCompetitors : this.viewCompetitors.filter((value) => cmts.value == value.ctm)
    }

    filterByKxtOne(kxtsOne: string[]): void {
        this.selectedKeyCharacteristicOneForCompetitors = kxtsOne.includes('Все') ? [] : kxtsOne;
        this.filterAll();
        this.setSelectAll("Kxt1");
    }

    filterByKxtTwo(kxysTwo: string[]): void {
        this.selectedKeyCharacteristicTwoForCompetitors = kxysTwo.includes('Все') ? [] : kxysTwo;
        this.filterAll();
        this.setSelectAll("Kxt2");
    }

    filterByMonitorDate(monitorDates: string[]): void {
        this.selectedMonitoringDateFilter = monitorDates.includes('Все') ? [] : monitorDates;
        this.filterAll();
        this.setSelectAll("MonitorDates");
    }

    toRow(competitor: RegularCompetitorsPricesView): CompetitorsPriceRow {
        const delta = this.computedDelta({lastPrice: competitor.lastPrice, competitorPrice: competitor.competitorPrice});
        return {
            ...competitor,
            competitorDate: new Date(competitor.priceDate),
            ctm: competitor.ctm == null ? this.$t('shared.boolFilter.no') as string : competitor.ctm,
            delta,
        }
    }

    onLoadCompetitors(response: RegularCompetitorsPricesView[]): void {
        this.resetCompetitors();
        this.competitors = response.map(this.toRow)
        this.viewCompetitors = this.competitors;
        this.$calc.competitorsCodes = this.competitors.map((i) => {
            return i.internalCode;
        });
        this.setSelectAll(null);
    }

    setSelectAll(exclude: 'SkuName' | 'CompetitorsName' | 'CompetitorsCode' | 'CompetitorPriority' | 'Delta' | 'LastPrice' | 'CompetitorPrices' | 'Kxt1' | 'Kxt2' | 'MonitorDates' | null): void {
        exclude != 'SkuName' && this.setSelectSkuName(this.viewCompetitors);
        exclude != 'CompetitorsName' && this.setSelectCompetitorsName(this.viewCompetitors);
        exclude != 'CompetitorsCode' && this.setSelectCompetitorsCode(this.viewCompetitors);
        exclude != 'CompetitorPriority' && this.setSelectCompetitorsPriority(this.viewCompetitors);
        exclude != 'LastPrice' && this.setSelectLastPrice(this.viewCompetitors);
        exclude != 'CompetitorPrices'&& this.setSelectCompetitorsPrice(this.viewCompetitors);
        exclude != 'Delta' && this.setSelectDelta(this.viewCompetitors);
        exclude != 'MonitorDates' && this.setSelectMonitorDate(this.viewCompetitors);
        exclude != 'Kxt1'&& this.setSelectCompetitorsKxtOne(this.viewCompetitors);
        exclude != 'Kxt2' && this.setSelectCompetitorsKxtTwo(this.viewCompetitors);
    }

    setSelectSkuName(response: CompetitorsPriceRow[]) {
        const skuNameOptions = response.map((value) => value.skuName)
                .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.skuNameFilterOptions = Array.from(new Set(skuNameOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsName(response: CompetitorsPriceRow[]) {
        const competitorsNameOptions = response.map((value) => value.competitorName)
                .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.competitorsNameFilterOptions = Array.from(new Set(competitorsNameOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsCode(response: CompetitorsPriceRow[]) {
        const competitorsCodeOptions = response.map((value) => value.competitorCode)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.competitorsCodeFilterOptions = Array.from(new Set(competitorsCodeOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsPriority(response: CompetitorsPriceRow[]) {
        const competitorsPriorityOptions = response.map((value) => value.competitorPriority).sort(compareNumber)
        this.competitorsPriorityFilterOptions = Array.from(new Set(competitorsPriorityOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectLastPrice(response: CompetitorsPriceRow[]) {
        const lastPriceOptions = response.map((value) => value.lastPrice).sort(compareNumber)
        this.lastPriceFilterOptions = Array.from(new Set(lastPriceOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectCompetitorsPrice(response: CompetitorsPriceRow[]) {
        const competitorsPriceOptions = response.map((value) => value.competitorPrice).sort(compareNumber)
        this.competitorsPriceFilterOptions = Array.from(new Set(competitorsPriceOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectDelta(response: CompetitorsPriceRow[]) {
        const deltaOptions = response.map((value) => this.computedDelta(value))
                .sort(compareNumber)
                .map((delta) => delta ? delta.toFixed(2) : '0')
        this.deltaFilterOptions = Array.from(new Set(deltaOptions)).map((deltaOption) => ({
            value: deltaOption,
            label: deltaOption,
        }))
    }

    setSelectCompetitorsKxtOne(response: CompetitorsPriceRow[]) {
        const competitorsKxtOneOptions = response.map((value) => value.keyCharacteristicOfTheProductIsOne)
                .filter((it) => it !== null)
                .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.keyCharacteristicOneForCompetitorsOptions = Array.from(new Set(competitorsKxtOneOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsKxtTwo(response: CompetitorsPriceRow[]) {
        const competitorsKxtTwoOptions = response.map((value) => value.keyCharacteristicOfTheProductIsTwo)
                .filter((it) => it !== null)
                .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.keyCharacteristicTwoForCompetitorsOptions = Array.from(new Set(competitorsKxtTwoOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectMonitorDate(response: CompetitorsPriceRow[]) {
        const formattedDates = response.map((value) => new Date(value.competitorDate))
                .sort((a: Date, b: Date) => (a.getTime() - b.getTime()))
                .map((value) => value.toLocaleDateString())
        this.monitoringDateFilterOptions = Array.from(new Set(formattedDates)).map((formattedDate) => ({
            value: formattedDate,
            label: formattedDate,
        }))
    }

    sortCompetitorPrice(a: CompetitorsPriceRow, b: CompetitorsPriceRow, key: string) {
        if (key === 'competitorPrice') {
            return a.competitorPrice - b.competitorPrice;
        }
        return false
    }

    competitorsSort(notSortingCompetitors: CompetitorsPriceRow[]): CompetitorsPriceRow[] {
        return notSortingCompetitors.sort(sortByFields((competitor) => [
                    competitor.competitorPrice,
                    competitor.competitorPriority,
                    competitor.competitorName,
                    competitor.storeFormat,
                    competitor.storeRegion,
                    competitor.skuName,
                ],
        ))
    }

    computedDelta = (item: { lastPrice: number,  competitorPrice: number}): number => {
        return ((item.lastPrice / item.competitorPrice - 1) * 100);
    }

    getColor = (delta: number) => {
        if (delta > 0) {
            return 'green';
        } else if (delta < 0) {
            return 'red';
        }
        return 'black';
    }

    isSelectedCompetitorCode(internalCode: string) {
        const index = this.$kviCart.competitorsCodes.findIndex((item) => {
            return item === internalCode
        });
        return index !== -1;
    }

    setSelectedCompetitorCode(internalCode: string, selected: boolean) {
        const index = this.$kviCart.competitorsCodes.findIndex((item) => {
            return item === internalCode
        });
        if (selected) {
            if (index === -1) {
                this.$kviCart.competitorsCodes.push(internalCode);
            }
        } else {
            if (index !== -1) {
                this.$kviCart.competitorsCodes.splice(index, 1);
            }
        }
        this.saveKviShoppingCart();
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null
            }
        }
    }

    async insertGlobalIndividualParamsForSkuPanel() {
        this.isApplyGlobalIndividualParamsLoading = true;
        try {
            await this.insertGlobalIndividualParams();
            this.refreshSkuTableInPanel();
        } catch (error) {
            console.error('Error applying global individual params:', error);
            this.showError(this.$t('kviCarts.messages.errorApplyIndividualParams') as string);
        } finally {
            this.isApplyGlobalIndividualParamsLoading = false;
        }
    }

    insertGlobalIndividualParamsForSkuTable() {
        this.insertGlobalIndividualParams();
        this.refreshSkuList();
    }

    addSelectedProductsToKviCart() {
        // Для обновления компонента, можно и через $emit конечно
        this.kviCartComponentKey += 1
        if (this.selectedProductInternalCodes.length === 0 || this.localSelectKviCart.id === -1) {
            return
        }
        const filter = this.getKviCartFilter()
        filter.internalCodesAndSkuNames = this.selectedProductInternalCodes
        filter.kviCartIdFilter = this.$kviCart.selectKviCart.id
        filter.kviCartNameFilter = this.$kviCart.selectKviCart.kviCartName
        this.httpAddSelectedProductsToKviCart(filter)
                .then((data) => {
                    this.selectedProductInternalCodes = [];
                    this.refreshSkuList();
                })
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorAddToCart') as string);
                })
    }

    addSelectedProductsToKviCartForTablePanel(evt: Event) {
        evt.preventDefault();
        // Для обновления компонента, можно и через $emit конечно
        this.kviCartComponentKey += 1
        if (this.selectedProductInternalCodes.length === 0 || this.$kviCart.selectKviCart.id === -1) {
          return
        }
        const filter = this.getKviCartFilter()
        filter.internalCodesAndSkuNames = this.selectedProductInternalCodes
        filter.kviCartIdFilter = this.$kviCart.selectKviCart.id
        filter.kviCartNameFilter = this.$kviCart.selectKviCart.kviCartName

        this.isAddProductsToCartLoading = true;
        //Перед добавлением в корзину проверить, есть ли выбранные товары в других корзинах в этой ТК
        this.httpExistsInOtherKviCartByFilterAndCode(filter)
            .then((exists) => {
                if (exists.data.length > 0) {
                  this.existsInOtherCartModal = true;
                  return;
                }

                return this.httpAddSelectedProductsToKviCart(filter)
                    .then(() => {
                      this.selectedProductInternalCodes = [];
                      this.fetchSkuList(true, 1);
                      this.refreshSkuList();
                      this.refreshSkuTableInPanel();
                    });
            })
            .catch((e) => {
              const errorMessage = e.message || this.$t('kviCarts.messages.unknownError') as string;
              this.showError(this.$t('kviCarts.messages.errorAddToCartWithMsg', { message: errorMessage }) as string);
            })
            .finally(() => {
              this.isAddProductsToCartLoading = false;
            });
    }

    deleteSelectedProductsFromKviCart() {
        if (this.selectedProductInternalCodes.length === 0) {
            return
        }
        // Extract only kviCartProductId values
        const kviCartProductIds = this.selectedProductInternalCodes
            .map(product => product.kviCartProductId)
            .filter(id => id !== undefined && id !== null) as number[]
        this.isDeleteProductsLoading = true;
        this.httpDeleteSelectedProductsFromKviCart(kviCartProductIds)
                .then((data) => {
                    this.selectedProductInternalCodes = []
                    this.fetchSkuList(true, 1);
                    this.refreshSkuTableInPanel()
                })
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorRemoveFromCart') as string);
                })
                .finally(() => {
                    this.isDeleteProductsLoading = false;
                })

    }

    async insertGlobalIndividualParams() {
        await this.downloadAllSku();
        await this.skuListWithAllProducts.forEach((sku) => {
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'selectCoefficent', this.globalIndividualPriceStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'priceIncreaseLimit', this.globalIndividualPriceIncreaseLimit!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'periodPriceIncreaseLimit', this.globalIndividualPeriodPriceIncreaseLimit!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'period', this.globalIndividualPeriod!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'marginalProfit', this.globalIndividualMarginalProfitability!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'marginalProfitKvi', this.$kviCart.minProfitKVI)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'marginalProfitCompetitors', this.$kviCart.competitorsMinimumProfit)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'kviStrategy', this.globalIndividualKviStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$kviCart.individualCommonParams, sku.internalCode, 'percentageOfCompetitorsPrice', this.globalIndividualPercentageOfCompetitorsPrice!!)
        });
    }

    isReactive(obj: any): boolean {
        return obj && obj.__ob__;
    }

    setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | SelectBox<any> | string) {
        const valueIsArray = Array.isArray(value);

        if (!(sku in config)) {
            if (valueIsArray) {
                this.$set(config, sku, {});
            } else {
                config[sku] = {};
            }
        } else {
            if (valueIsArray && !!config[sku] && !this.isReactive(config[sku])) {
                const skuConfig = Object.assign({}, config[sku]);

                delete config[sku];

                this.$set(config, sku, skuConfig);
            }
        }

        if (valueIsArray) {
            this.$set(config[sku], property, value);
        } else if (typeof value === 'number' && Number.isNaN(value)) {
            config[sku][property] = null;
        } else {
            config[sku][property] = value;
        }
    }

    getSelectIndividConfig(internalCode: any, key: any) {
       const value = this.getCalcIndividConfig(this.$kviCart.individualCommonParams, internalCode, key) as {label: string, value: any}
       if(value && value.value){
        return value.value.enum
       }
       return value
    }

    clearAllGlobalIndividualParams() {
        this.globalIndividualPriceStrategy = null;
        this.globalIndividualPriceIncreaseLimit = null;
        this.globalIndividualPeriodPriceIncreaseLimit = null;
        this.globalIndividualPeriod = null;
        this.globalIndividualMarginalProfitability = null;
        this.globalIndividualKviStrategy = null;
        this.globalIndividualPercentageOfCompetitorsPrice = null;
        this.globalIndividualMarginalBlockButton = false;
        this.globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
        this.globalIndividualPriceIncreaseLimitBlockButton = false;
        this.globalIndividualMarginalErrorText = '';
    }

    calcRegularPricesProfitability() {
        if (this.$kviCart.selectMarket.id === -1 || this.regularPricesProfitability != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculated = true;
        const filter = this.getSkuFilter()
        this.httpGetRegularPricesProfitability(filter)
                .then((number) => {
                    this.regularPricesProfitability = number.data;
                    this.isRegularPricesProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorCalcRegularPriceProfit') as string);
                    this.isRegularPricesProfitabilityCalculated = false;
                })
    }

    calcActualProfitability() {
        if (this.$kviCart.selectMarket.id === -1 || this.actualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculated = true;
        const filter = this.getSkuFilter()
        this.httpGetActualProfitability(filter)
                .then((number) => {
                    this.actualProfitability = number.data;
                    this.isActualProfitabilityCalculated = false;
                })
                .catch((e) => {
                    this.showError(this.$t('kviCarts.messages.errorCalcActualProfit') as string);
                    this.isActualProfitabilityCalculated = false;
                })
    }

    calculateOnlyLastPricesInSku() {
        this.needCalculateSkuLastPricesOnly = true;
        this.refreshSkuList();
        this.calcSkuLastPricesButtonDisabled = true;
    }

    calculateOnlyLastPricesInSkuInPanel() {
        this.needCalculateSkuLastPricesOnly = true;
        this.refreshSkuTableInPanel();
        this.calcSkuLastPricesButtonDisabled = true;
    }

    calculateOnlyActualProfitInSku() {
        this.needCalculateSkuActualProfitabilityOnly = true;
        this.refreshSkuList();
        this.calcSkuActualProfitButtonDisabled = true;
    }

    calculateOnlyActualProfitInSkuInPanel() {
        this.needCalculateSkuActualProfitabilityOnly = true;
        this.refreshSkuTableInPanel();
        this.calcSkuActualProfitButtonDisabled = true;
    }

    goToParams() {
      this.currentMainTab = "mainParameters"
    }

    goToSkuList(internalCode: string) {
        this.skuFilter = internalCode;
        this.loadSkuWithoutCalc();
        this.tableKey = Math.random();
        this.currentMainTab = "listOfProducts"
        this.refreshSkuTableInPanel();
    }

    packageKviRecommendsCalc() {
        if (this.$packageKviRecommends.selectMarket.id <= 0) {
            this.showError(this.$t('kviCarts.messages.companyNotSelected') as string);
            return;
        }
        const filters = this.getPackageKviRecommendsFilter();
        this.savePackageKviRecommends();
        this.httpAddPackageKviRecommendsTask(filters)
                .then((r) => {
                            this.$log.debug('Create task', r.data);
                            this.showInfo(this.$t('kviCarts.messages.kviRecommendationsStarted') as string);
                        },
                )
                .catch((e) => {
                    this.showError(e.response.data);
                });
    }

    onMainTabsClicked(key:string) {
      this.currentMainTab = key
      switch (key) {
        case "listOfProducts":
              this.loadSkuWithoutCalc()
              break;
        case "listOfCompetitors":
              // @ts-ignore
              this.listCompetitors({}, () => {})
              break;
        case "packageSearchKvi":
              // @ts-ignore
              this.downloadKviRecommendsActiveParams()
              break;
        default:
          return
      }
    }

    private loadKviCartParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindKviCartParams, findFilterParams)
                    .then((r) => {
                        if (!r.ignore) {
                            const resp = r.response;
                            if (resp.status === 200) {
                                const filter = resp.data.filters;
                                this.applyKviCartFilters(this.$kviCart, filter);
                            }
                        }
                        resolve(!r.ignore);
                    })
                    .catch((e) => {
                        reject(e)
                    })
        });
    }

    private loadKviCartIndividual(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpLoadKviCartIndividual, findFilterParams)
                    .then((r) => {
                        if (!r.ignore) {
                            const resp = r.response;
                            if (resp.status === 200) {
                                const params = resp.data;
                                this.applyKviCartIndividualConfig(this.$kviCart, params);
                            }
                        }
                        resolve(!r.ignore);
                    })
                    .catch((e) => reject(e))
        });
    }

    private refreshSkuList() {
        const oldRefreshId = this.refreshSkuListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshSkuListId === timeoutId) {
                this.skuListCurrentPage = 1;
                const skuTableRef = this.$refs.skuTableRef as any;
                if (typeof skuTableRef !== 'undefined') {
                  skuTableRef.$forceUpdate();
                }
                this.refreshSkuListId = -1;
            }
        }, 250);
        this.refreshSkuListId = timeoutId;
        this.isFiltersChanged = 1;
    }

    private refreshSkuTableInPanel() {
        const oldRefreshId = this.refreshTabPanelSkuListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshTabPanelSkuListId === timeoutId) {
                this.pagination.current = 1;
                const skuTableInPanel = this.$refs.skuTableInPanel as any;
                if (typeof skuTableInPanel !== 'undefined') {
                    skuTableInPanel.$forceUpdate();
                }
                this.refreshTabPanelSkuListId = -1;
            }
        }, 250);
        this.refreshTabPanelSkuListId = timeoutId;
        this.isFiltersChanged = 1;
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments] = this.selectData();
        return {
            type: taskType,
            tradingId: this.$kviCart.selectMarket.id,
            storeFormat: this.$kviCart.formatSelected == null || this.$kviCart.formatSelected <= 0 ? null : [this.$kviCart.formatSelected],
            storeCluster: this.$kviCart.clusterSelected.length ? this.$kviCart.clusterSelected : null,
            groups: selectGroups,
            categories: selectCategories,
            subcategories: selectSubcategories,
            subcategory: this.$kviCart.subcategory == null || this.$kviCart.subcategory <= 0 ? null : [this.$kviCart.subcategory],
            productSegments: selectSegments,
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getKviRecommendsTaskInfo(filterType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions, , selectFormats] = this.kviRecommendsSelectData();
        return {
            type: filterType,
            tradingId: this.$packageKviRecommends.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.$packageKviRecommends.categoriesOfProduct),
            groups: LocalData.filterNumberArrays(this.$packageKviRecommends.groupsOfProduct),
            subcategory: LocalData.filterNumberArrays(this.$packageKviRecommends.subcategories, true),
            segments: null,
            storeFormat: selectFormats,
            storeCluster: this.$packageKviRecommends.clusterSelected,
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getFullCommonFilter(): KviShoppingCartFilters {
        const [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments] = this.selectData();
        const allCheck = this.$kviCart.allCheck;
        const discountPrice = this.$kviCart.discountPrice;
        const pennies = this.$kviCart.pennies;
        const countAtLastPurchasePrice = this.$kviCart.countAtLastPurchasePrice;
        const countAtFuturePurchasePrice = this.$kviCart.countAtFuturePurchasePrice;
        const allNewPricesWithoutPennies = this.$kviCart.allNewPricesWithoutPennies;
        const allClaster = this.$kviCart.allClaster;
        const xyzChecked = this.$kviCart.xyzChecked;
        const uvwChecked = this.$kviCart.uvwChecked;
        const individualConfigsObj = Object.create(null);
        // tslint:disable-next-line: forin
        for (const key in this.$kviCart.individualCommonParams) {
            const value = this.$kviCart.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }
        return {
            allCheck,
            discountPrise: discountPrice,
            pennies,
            countAtLastPurchasePrice,
            countAtFuturePurchasePrice,
            allNewPricesWithoutPennies,
            xyzChecked,
            uvwChecked,
            allClaster,
            coefficientK1: this.$kviCart.selectCoefficent.value.k1,
            coefficientK2: this.$kviCart.selectCoefficent.value.k2,
            category: null,
            storeCluster: this.$kviCart.clusterSelected,
            seasonValues: [],
            buyerSegments: [],
            spreadUVWParams: this.$kviCart.uvwParams,
            spreadXYZParams: this.$kviCart.xyzParams,
            storeRegionValues: selectRegions,
            groupsOfProduct: selectGroups,
            categories: selectCategories,
            subcategories: selectSubcategories,
            productSegments: selectSegments,
            newProductLifespanInDays: this.$kviCart.newProductLifespanInDays,
            storeFormat: this.$kviCart.formatSelected,
            tradingId: this.$kviCart.selectMarket.id,
            calculationDepth: +this.$kviCart.calculationDepth,
            correlation: this.$kviCart.correlation ? this.$kviCart.correlation : 0.7,
            highElasticity: this.$kviCart.highElasticity ? this.$kviCart.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$kviCart.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$kviCart.competitorsPrices,
            kviStrategy: this.$kviCart.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$kviCart.percentageOfCompetitorsPrice,
            marginalProfitability: this.$kviCart.marginalProfitability,
            marginalProfit: this.$kviCart.marginalProfit,
            marginalProfitKvi: this.$kviCart.minProfitKVI,
            marginalProfitCompetitors: this.$kviCart.competitorsMinimumProfit,
            maxMarginalProfit: this.$kviCart.maxMarginalProfit != null ? this.$kviCart.maxMarginalProfit : 100,
            marginalPriceDifference: this.$kviCart.marginalPriceDifference,
            calculationDay: +this.$kviCart.calculationDay,
            priceCorridor: this.$kviCart.priceCorridor,
            changePriceCorridor: this.$kviCart.changePriceCorridor,
            priceIncreaseLimit: this.$kviCart.priceIncreaseLimit,
            fixLowerBorder: this.$kviCart.fixLowerBorder,
            individualCommonParams: individualConfigsObj,
            depthToPurchasePrice: this.$kviCart.depthToPurchasePrice,
            priceFamilies: this.$kviCart.priceFamilies,
            hardPriceFamilies: this.$kviCart.hardPriceFamilies,
            groupOfProduct: this.$kviCart.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$kviCart.selectCoefficent.value.enum!,
            byPromoPrices: this.$kviCart.byPromoPrices,
            useCompetitorsPrices: this.$kviCart.useCompetitorsPrices,
            competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
            competitorsCodes: this.$kviCart.competitorsCodes,
            competitorsPriceMethod: this.$kviCart.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$kviCart.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$kviCart.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$kviCart.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$kviCart.competitorsMaximumProfit != null ? this.$kviCart.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$kviCart.competitorsControlParam,
            competitorsPriceStrategy: this.$kviCart.competitorsPriceStrategy.value,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            calculateByRegression: !this.$kviCart.calculateByElasticity,
            recalculateCtm: this.$kviCart.recalculateCtm,
            priceChangeLimit: this.$kviCart.priceChangeLimit,
            priceChangeLimitKvi: this.$kviCart.priceChangeLimitKvi,
            priceChangeLimitComp: this.$kviCart.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: false,
            optimizationDiff: -1,
            calculatePYR: this.$kviCart.calculatePYR,
            periodPriceIncreaseLimit: this.$kviCart.periodPriceIncreaseLimit,
            period: this.$kviCart.period.value,
            decreaseSalesCount: this.$kviCart.decreaseSalesCount,
            newProductPriceStrategy: this.$kviCart.newProductPriceStrategy.value,
            priceGap: this.$kviCart.priceGap,
            priceGapCtmPc: this.$kviCart.priceGapCtmPc,
            findAutomaticallyPriceSegments: false,
            countPriceSegments: -1,
            promoCalc: false,
            percentageOfRecommendsKviCount: this.$kviCart.percentageOfRecommendsKviCount,
            saveKviSign: this.$kviCart.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$kviCart.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$kviCart.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$kviCart.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$kviCart.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForAddCtmPurpose,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.$kviCart.calculateCompAllowedDeviation,
            useCompElasticity: this.$kviCart.useCompElasticity,
            minProfitKVI: this.$kviCart.minProfitKVI,
            maxProfitKVI: this.$kviCart.maxProfitKVI != null ? this.$kviCart.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            randomPennies: this.$kviCart.randomPennies,
            manualPennies: this.$kviCart.manualPennies,
            calcWithBatchNumber: true,
            competitorPriceControlParameterPc: this.$kviCart.competitorPriceControlParameterPc,
            thompsonSampling: this.$kviCart.thompsonSampling,
            percentileType: this.$kviCart.percentileType.value,
            revaluationCalculateParams: this.$kviCart.revaluationCalculateParams,
            isFixPricePromo: this.$kviCart.isFixPricePromo,
            spreadByPriceSegments: this.$calc.spreadByPriceSegments,
            kviCartIdFilter: this.$kviCart.selectKviCart.id,
            autoApprovalParams: this.$kviCart.autoApprovalParams,
        };
    }

    private getKviCartFilter(): KviCartFilters {
        const [selectRegions] = this.selectData();
        const clusterSelected = this.$kviCart.clusterSelected.length > 0 ? this.$kviCart.clusterSelected[0] : null;
        const revaluationCalculateParams = {
          revaluationNumber: this.$kviCart.revaluationCalculateParams.revaluationNumber,
          revaluationFrequencyCalculationDepth: this.$kviCart.revaluationCalculateParams.revaluationFrequencyCalculationDepth,
          purchasePriceDelta: this.$kviCart.revaluationCalculateParams.purchasePriceDelta,
          competitorsPriceDelta: this.$kviCart.revaluationCalculateParams.competitorsPriceDelta,
          calculateByAllCompetitors: this.$kviCart.revaluationCalculateParams.calculateByAllCompetitors,
          useRevaluationCalculate: this.$kviCart.revaluationCalculateParams.useRevaluationCalculate
        }
        return {
            kviCartId: this.$kviCart.selectKviCart.id,
            tradingId: this.$kviCart.selectMarket.id,
            storeFormat: this.$kviCart.formatSelected,
            groupOfProduct: null,
            category: null,
            subcategory: null,
            segment: null,
            storeRegionValues: selectRegions,
            groupsOfProduct: null,
            categories: null,
            subcategories: null,
            productSegments: null,
            byPromoPrices: this.$kviCart.byPromoPrices,
            downloadParamsWithCategory: this.$kviCart.downloadParamsWithCategory,
            storeCluster: clusterSelected,
            separateClusters: this.$kviCart.separateClusters,
            coefficientK1: this.$kviCart.selectCoefficent.value.k1,
            coefficientK2: this.$kviCart.selectCoefficent.value.k2,
            marginalProfit: this.$kviCart.marginalProfit,
            marginalProfitKvi: this.$kviCart.minProfitKVI,
            marginalProfitCompetitors: this.$kviCart.competitorsMinimumProfit,
            maxMarginalProfit: this.$kviCart.maxMarginalProfit != null ? this.$kviCart.maxMarginalProfit : 100,
            priceIncreaseLimit: this.$kviCart.priceIncreaseLimit,
            fixLowerBorder: this.$kviCart.fixLowerBorder,
            priceChangeLimit: this.$kviCart.priceChangeLimit,
            priceChangeLimitKvi: this.$kviCart.priceChangeLimitKvi,
            priceChangeLimitComp: this.$kviCart.priceChangeLimitComp,
            periodPriceIncreaseLimit: this.$kviCart.periodPriceIncreaseLimit,
            period: this.$kviCart.period.value,
            competitorsPricesParams: this.$kviCart.competitorsPrices,
            percentageOfCompetitorsPrice: this.$kviCart.percentageOfCompetitorsPrice,
            kviStrategy: this.$kviCart.kviStrategy.value,
            minProfitKVI: this.$kviCart.minProfitKVI,
            maxProfitKVI: this.$kviCart.maxProfitKVI != null ? this.$kviCart.maxProfitKVI : 100,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            percentageOfRecommendsKviCount: this.$kviCart.percentageOfRecommendsKviCount,
            useSegmentsPriceInSearchKVIRecParam: this.$kviCart.useSegmentsPriceInSearchKVIRecParam,
            saveKviSign: this.$kviCart.saveKviSign,
            useCompetitorsForKviRecommends: this.$kviCart.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$kviCart.competitorsPeriodForKviRecommends,
            useCompetitorsPrices: this.$kviCart.useCompetitorsPrices,
            useCompElasticity: this.$kviCart.useCompElasticity,
            calculateCompAllowedDeviation: this.$kviCart.calculateCompAllowedDeviation,
            competitorsPriceMethod: this.$kviCart.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$kviCart.competitorsPriceAdjustment,
            competitorsControlParam: this.$kviCart.competitorsControlParam,
            competitorsPriceStrategy: this.$kviCart.competitorsPriceStrategy.value,
            daysToPriceChangeStart: this.$kviCart.daysToPriceChangeStart && this.$kviCart.daysToPriceChangeStart > 0 
                ? this.$kviCart.daysToPriceChangeStart 
                : null,
            daysToPriceChangeFinish: this.$kviCart.daysToPriceChangeFinish && this.$kviCart.daysToPriceChangeFinish > 0 
                ? this.$kviCart.daysToPriceChangeFinish 
                : null,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
            competitorsInfluencesCoef: this.$kviCart.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$kviCart.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$kviCart.competitorsMaximumProfit != null ? this.$kviCart.competitorsMaximumProfit : 100,
            competitorsCodes: this.$kviCart.competitorsCodes,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForDeleteKvi,
            productRangesAndInternalCodes: this.productRangesArray,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$kviCart.selectCoefficent.value.enum!,
            // tslint:disable-next-line: no-non-null-assertion
            individualCommonParams: {},
            kviCartChangePrices: this.$kviCart.kviCartChangePrices.value,
            competitorPriceControlParameterPc: this.$kviCart.competitorPriceControlParameterPc,
            revaluationCalculateParams: revaluationCalculateParams,
            checkMarginDeclineProfit: this.$kviCart.checkMarginDeclineProfit,
            declineProfitabilityPc: this.$kviCart.declineProfitabilityPc,
            searchPreviousPricesDepth: this.$kviCart.searchPreviousPricesDepth,
            thompsonSampling: this.$kviCart.thompsonSampling,
            percentileType: this.$kviCart.percentileType.value,
            isFixPricePromo: this.$kviCart.isFixPricePromo,
            autoApprovalParams: this.$kviCart.autoApprovalParams,
        };
    }

    private getPackageCalcConfig(): KviCartPackageConfig {
        const [selectRegions] = this.selectData();
        const paramFilters = this.getKviCartFilter()
        return {
            kviCartChangePrices: this.$kviCart.kviCartChangePrices.value,
            kviCartId: this.$kviCart.selectKviCart.id,
            kviCartsParams: paramFilters,
            coefficientK1: this.$kviCart.selectCoefficent.value.k1,
            coefficientK2: this.$kviCart.selectCoefficent.value.k2,
// tslint:disable-next-line: no-non-null-assertion
            categories: null,
            subcategories: null,
            productSegments: null,
            storeCluster: this.$kviCart.clusterSelected.length ? this.$kviCart.clusterSelected : null,
            storeRegionValues: selectRegions,
            groupsOfProduct: null,
            applyOmnichannel: false,
            sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            isFixPricePromo: this.$kviCart.isFixPricePromo,
            storeFormat: this.$kviCart.formatSelected == null || this.$kviCart.formatSelected <= 0 ? [] : [this.$kviCart.formatSelected],
            tradingId: this.$kviCart.selectMarket.id,
// tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$kviCart.selectCoefficent.value.enum!,
            separateSubcategories: true,
            separateClusters: this.$kviCart.separateClusters,
            manualPennies: this.$kviCart.manualPennies,
            percentileType: this.$kviCart.percentileType.value,
            calcWithBatchNumber: true,
            thompsonSampling: false,
            useSkuRotation: false,
            useFixedPrices: true,
            autoApprovalParams: this.$kviCart.autoApprovalParams,
        };
    }

    private getSkuFilter(isForAddProductsModal: boolean = false): KviCartsSkuFilter {
        const [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments] = this.selectData(isForAddProductsModal);
        const clusterSelected = this.$kviCart.clusterSelected.length > 0 ? this.$kviCart.clusterSelected[0] : null;

        return {
            storeCluster: clusterSelected,
            groupsOfProduct: selectGroups,
            categories: selectCategories,
            subcategories: selectSubcategories,
            productSegments: selectSegments,
            seasonValues: [],
            buyerSegments: [],
            storeRegionValues: selectRegions,
            storeFormat: this.$kviCart.formatSelected,
            tradingId: this.$kviCart.selectMarket.id,
            calculationDepth: this.$kviCart.calculationDepth,
            calculationDay: this.$kviCart.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: this.$kviCart.groupOfProduct,
            category: this.$kviCart.categoryOfProduct,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm: this.selectCTM,
            priceSegments: this.selectSegmentPrice,
            needCalculateSku: this.skuListWithCalculating,
            needCalculateSkuLastPricesOnly: this.needCalculateSkuLastPricesOnly,
            needCalculateSkuActualProfitabilityOnly: this.needCalculateSkuActualProfitabilityOnly,
            kviRecommendation: this.selectKVIRecommends,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
            recipeAttributes: this.selectRecipeAttributes,
            treatmentAttributes: this.selectTreatmentAttributes,
            alwaysCalculateProductSegments: true,
            productRangeFilter: this.selectProductLine,
            groupFilterInSkuList: this.$kviCart.groupOfProduct || (!isForAddProductsModal ? this.cartProductsTableFilterValues.group : this.defaultFilterValue.value),
            categoryFilterInSkuList: this.$kviCart.categoryOfProduct || (!isForAddProductsModal ? this.cartProductsTableFilterValues.category : this.defaultFilterValue.value),
            subcategoryFilterInSkuList: this.$kviCart.subcategory || (!isForAddProductsModal ? this.cartProductsTableFilterValues.subcategory : this.defaultFilterValue.value),
            // this.selectFilterProductSegment ниже не используется (всегда был = -1), возможно стоит добавить из значение фильтра таблицы по аналогии
            segmentFilterInSkuList: this.$kviCart.segment || this.selectFilterProductSegment,
            competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
            kviCartIdFilter: this.$kviCart.selectKviCart.id,
            sortingField: null,
            isKviCartCompetitorsGrid: false
        };
    }

    private getCompetitorsFilter(isForAddProductsModal: boolean = false): CompetitorsPriceFilter {
        const [selectRegions, selectGroups, selectCategories, selectSubcategories, selectSegments] = this.selectData(isForAddProductsModal);
        const clusterSelected = this.$kviCart.clusterSelected.length > 0 ? this.$kviCart.clusterSelected[0] : null;
        return {
            discountPrise: this.$kviCart.discountPrice,
            storeCluster: clusterSelected,
            groupsOfProduct: selectGroups,
            categories: selectCategories,
            subcategories: selectSubcategories,
            productSegments: selectSegments,
            seasonValues: [],
            buyerSegments: [],
            storeRegionValues: selectRegions,
            storeFormat: this.$kviCart.formatSelected,
            tradingId: this.$kviCart.selectMarket.id,
            calculationDepth: +this.$kviCart.calculationDepth,
            calculationDay: +this.$kviCart.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: this.$kviCart.groupOfProduct,
            category: this.$kviCart.categoryOfProduct,
            competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
            promo: false,
            internalCodes: this.cartInternalCodes,
            sortingField: this.sortingField,
            isKviCartCompetitorsGrid: true
        };
    }

    private getPackageKviRecommendsFilter(): PackageKviRecommendsConfig {
        // tslint:disable-next-line: no-non-null-assertion
        let groups = LocalData.filterNumberArrays(this.$packageKviRecommends.groupsOfProduct)!!;
        // Если не выбрали ни одной группы и оставили опцию "Все"
        if (groups.length === 0) {
            groups = this.taskInfoPackageKviRecommends.groupsOfProduct.map((group) => {
                // tslint:disable-next-line: no-non-null-assertion
                return group.value!!
            });
            // Удаляем из массива опцию "Все"
            groups.splice(0, 1)
        }
        const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.kviRecommendsSelectData();
        const selectClusters: number[] = (this.$packageKviRecommends.clusterSelected.length === 0 || (this.$packageKviRecommends.clusterSelected.length && this.$packageKviRecommends.clusterSelected[0] === 0))
                // tslint:disable-next-line: no-non-null-assertion
                ? [] : LocalData.filterNumberArrays(this.$packageKviRecommends.clusterSelected)!!;
        const calculationDay = this.$packageKviRecommends.calculationDepth * 7;
        return {
// tslint:disable-next-line: no-non-null-assertion
            categories: LocalData.filterNumberArrays(this.$packageKviRecommends.categoriesOfProduct)!!,
            storeCluster: selectClusters,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            storeFormat: selectFormats,
            tradingId: this.$packageKviRecommends.selectMarket.id,
            calculationDepth: +this.$packageKviRecommends.calculationDepth,
          //SP-59005 изначально было 28 по умолчанию для рекоммендаций KVI
            calculationDay: +calculationDay,
// tslint:disable-next-line: no-non-null-assertion
            groupsOfProduct: groups,
// tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$packageKviRecommends.subcategories),
            productSegments: LocalData.filterNumberArrays(this.$packageKviRecommends.productSegments),
            separateSubcategories: this.$packageKviRecommends.separateSubcategories,
            separateClusters: this.$packageKviRecommends.separateClusters,
            packageCalc: true,
            categoryStrategy: this.$packageKviRecommends.categoryStrategy.value,
            calcWithBatchNumber: false,
            competitorsPricesParams: this.$packageKviRecommends.competitorsPrices,
            percentageOfCompetitorsPrice: this.$packageKviRecommends.percentageOfCompetitorsPrice,
            kviStrategy: this.$packageKviRecommends.kviStrategy.value,
            minProfitKVI: this.$packageKviRecommends.minProfitKVI,
            maxProfitKVI: this.$packageKviRecommends.maxProfitKVI,
            roundKviCompetitorPrice: this.$packageKviRecommends.roundKviCompetitorPrice,
            percentageOfRecommendsKviCount: this.$packageKviRecommends.percentageOfRecommendsKviCount,
            useSegmentsPriceInSearchKVIRecParam: this.$packageKviRecommends.useSegmentsPriceInSearchKVIRecParam,
            saveKviSign: this.$packageKviRecommends.saveKviSign,
            useCompetitorsForKviRecommends: this.$packageKviRecommends.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$packageKviRecommends.competitorsPeriodForKviRecommends,
            spreadUVWParams: this.$packageKviRecommends.uvwParams,
            spreadXYZParams: this.$packageKviRecommends.xyzParams,
            intervalOfUltimateElasticity: this.$packageKviRecommends.intervalOfUltimateElasticity,
            allCheck: this.$packageKviRecommends.allCheck,
            discountPrise: this.$packageKviRecommends.discountPrice,
            allClaster: this.$packageKviRecommends.allClaster,
            thompsonSampling: this.$packageKviRecommends.thompsonSampling,
            applyOmnichannel: false,
            sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            useSkuRotation: false,
            isFixPricePromo: this.$kviCart.isFixPricePromo,
            useFixedPrices: true,
        };
    }

    get saveState(): boolean {
        return this.$kviCart.selectKviCart.id === -1 || this.$kviCart.selectMarket.id === -1 || this.calcButtonState();
    }

    get paramsSum(): boolean {
        const u = this.$kviCart.uvwParams.u;
        const v = this.$kviCart.uvwParams.v;
        const w = this.$kviCart.uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    get paramsSumXYZ(): boolean {
        const x = this.$kviCart.xyzParams.x;
        const y = this.$kviCart.xyzParams.y;
        const z = this.$kviCart.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get calculationDepthValidate(): boolean {
        return this.$kviCart.calculationDepth * 7 >= this.$kviCart.calculationDay;
    }

    get calculationDayValidate(): boolean {
        return this.$kviCart.calculationDay > 0;
    }

    get priceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.$kviCart.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
    }

    get competitorsPricesValidate(): boolean {
        const competitorsP = this.$kviCart.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get percentageOfRecommendsKviValidate(): boolean {
        const kviRecommends = this.$kviCart.percentageOfRecommendsKviCount.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);
        return numberPattern.test(kviRecommends);
    }

    get competitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.$kviCart.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '';
    }

    get competitorsMaximumProfitValidate(): boolean {
        const competitorsMaximumProfit = this.$kviCart.competitorsMaximumProfit != null ? this.$kviCart.competitorsMaximumProfit : 100;
        const competitorsMinimumProfit = this.$kviCart.competitorsMinimumProfit != null ? this.$kviCart.competitorsMinimumProfit : 0;
        if (competitorsMaximumProfit < competitorsMinimumProfit) {
            this.competitorsMaximumProfitErrorText = this.$t('kviCarts.validation.maxProfitGteMin') as string
        } else if (competitorsMaximumProfit > 100) {
            this.competitorsMaximumProfitErrorText = this.$t('kviCarts.validation.maxProfitLte100') as string
        } else {
            this.competitorsMaximumProfitErrorText = ''
        }
        return competitorsMaximumProfit >= competitorsMinimumProfit && competitorsMaximumProfit <= 100;
    }

    get priceChangeLimitKviValidate(): boolean {
        const priceChangeLimitKvi = this.$kviCart.priceChangeLimitKvi;
        return priceChangeLimitKvi != null
            && priceChangeLimitKvi.toString() !== ''
            && priceChangeLimitKvi >= 0
            && priceChangeLimitKvi < 100
    }

    get daysToPriceChangeStartValidateKvi(): boolean | null {
        if (this.$kviCart.daysToPriceChangeStart == null || this.$kviCart.daysToPriceChangeStart === 0) {
            return null;
        }
        return this.$kviCart.daysToPriceChangeStart > 0;
    }

    get daysToPriceChangeFinishValidateKvi(): boolean | null {
        if (this.$kviCart.daysToPriceChangeFinish == null || this.$kviCart.daysToPriceChangeFinish === 0) {
            return null;
        }
        if (this.$kviCart.daysToPriceChangeFinish <= 0) {
            return false;
        }
        if (this.$kviCart.daysToPriceChangeStart != null && this.$kviCart.daysToPriceChangeStart > 0) {
            return this.$kviCart.daysToPriceChangeFinish >= this.$kviCart.daysToPriceChangeStart;
        }
        return true;
    }

    setNonNegativeInteger(input: string): string {
        const parsed = parseInt(input, 10);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return '0';
        }
        return parsed.toString();
    }

    get priceChangeLimitCompValidate(): boolean {
        const priceChangeLimitComp = this.$kviCart.priceChangeLimitComp;
        return priceChangeLimitComp != null
            && priceChangeLimitComp.toString() !== ''
            && priceChangeLimitComp >= 0
            && priceChangeLimitComp < 100
    }

    get minProfitKVIValidate(): boolean {
        const minProfitKvi = this.$kviCart.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get maxProfitKVIValidate(): boolean {
        const maxProfitKVI = this.$kviCart.maxProfitKVI != null ? this.$kviCart.maxProfitKVI : 100;
        const minProfitKVI = this.$kviCart.minProfitKVI != null ? this.$kviCart.minProfitKVI : 0;
        if (maxProfitKVI < minProfitKVI) {
            this.maxProfitKVIErrorText = this.$t('kviCarts.validation.maxProfitGteMin') as string
        } else if (maxProfitKVI > 100) {
            this.maxProfitKVIErrorText = this.$t('kviCarts.validation.maxProfitLte100') as string
        } else {
            this.maxProfitKVIErrorText = ''
        }
        return maxProfitKVI >= minProfitKVI && maxProfitKVI <= 100;
    }

    get marginalProfitValidate(): boolean {
        const marginalProfit = this.$kviCart.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorText = this.$t('kviCarts.validation.negativeProfitWarning') as string
        } else {
            this.marginalErrorText = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get maxMarginalProfitValidate(): boolean {
        const maxMarginalProfit = this.$kviCart.maxMarginalProfit != null ? this.$kviCart.maxMarginalProfit : 100;
        const marginalProfit = this.$kviCart.marginalProfit != null ? this.$kviCart.marginalProfit : 0;
        if (maxMarginalProfit < marginalProfit) {
            this.maxMarginalErrorText = this.$t('kviCarts.validation.maxProfitGteMin') as string
        } else if (maxMarginalProfit > 100) {
            this.maxMarginalErrorText = this.$t('kviCarts.validation.maxProfitLte100') as string
        } else {
            this.maxMarginalErrorText = ''
        }
        return maxMarginalProfit >= marginalProfit && maxMarginalProfit <= 100;
    }

    get globalIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalIndividualMarginalErrorText = this.$t('kviCarts.validation.negativeProfitWarning') as string
            } else {
                this.globalIndividualMarginalErrorText = ''
            }
            this.globalIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalIndividualPeriodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.globalIndividualPeriodPriceIncreaseLimit;
        if (periodPriceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPeriodPriceIncreaseLimitBlockButton = periodPriceIncreaseLimit < 0;
            return periodPriceIncreaseLimit >= 0;
        }
    }

    get globalIndividualPriceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.globalIndividualPriceIncreaseLimit;
        if (priceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPriceIncreaseLimitBlockButton = priceIncreaseLimit < 0 || priceIncreaseLimit > 100;
            return priceIncreaseLimit >= 0 && priceIncreaseLimit < 100;
        }
    }

    get priceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.$kviCart.priceChangeLimit;
        return priceChangeLimit.toString() !== '' && priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get periodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.$kviCart.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get highElasticityCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const highElasticity = this.$kviCart.highElasticity.toString();
        this.$log.debug(highElasticity.length > 0, numberPattern.test(highElasticity));
        return numberPattern.test(highElasticity);
    }

    get calcButt(): boolean {
        return this.calcButtonState();
    }

    get isMarketSelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$kviCart.selectMarket.id !== -1;
    }

    get kviRecommendsParamsSumXYZ(): boolean {
        const x = this.$packageKviRecommends.xyzParams.x;
        const y = this.$packageKviRecommends.xyzParams.y;
        const z = this.$packageKviRecommends.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get kviRecommendsParamsSumUVW(): boolean {
        const u = this.$packageKviRecommends.uvwParams.u;
        const v = this.$packageKviRecommends.uvwParams.v;
        const w = this.$packageKviRecommends.uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    get isKviRecommendsClustersSelected(): boolean {
        const selectClusters: number[] = (this.$packageKviRecommends.clusterSelected.length === 0 || (this.$packageKviRecommends.clusterSelected.length && this.$packageKviRecommends.clusterSelected[0] === 0))
                // tslint:disable-next-line: no-non-null-assertion
                ? [] : LocalData.filterNumberArrays(this.$packageKviRecommends.clusterSelected)!!;
        return selectClusters.length > 0;
    }

    get kviRecommendsCompetitorsPricesValidate(): boolean {
        const competitorsP = this.$packageKviRecommends.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get kviRecommendsCountPriceSegmentsValidate(): boolean {
        const countSegments = this.kviRecommendsCountPriceSegments;
        return countSegments > 0;
    }

    get kviRecommendsMinProfitKVIValidate(): boolean {
        const minProfitKvi = this.$packageKviRecommends.minProfitKVI;
        return minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get kviRecommendsPercentageOfRecommendsKviValidate(): boolean {
        const kviRecommends = this.$packageKviRecommends.percentageOfRecommendsKviCount.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);
        return numberPattern.test(kviRecommends);
    }

    get kviRecommendsInputInterval(): boolean {
        const lowerI = this.$packageKviRecommends.intervalOfUltimateElasticity.lower.toString();
        const upperI = this.$packageKviRecommends.intervalOfUltimateElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get competitorPriceControlParameterPcValidate(): boolean {
        return this.$kviCart.competitorPriceControlParameterPc.toString() !== '' && this.$kviCart.competitorPriceControlParameterPc > 0 && this.$kviCart.competitorPriceControlParameterPc <= 100;
    }

    get isGroupsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$packageKviRecommends.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

    get isCategoriesSelected(): boolean {
        const categories = LocalData.filterNumberArrays(this.$packageKviRecommends.categoriesOfProduct);
        return categories != null && categories.length > 0;
    }

    get isSubCategoriesSelected(): boolean {
      const subCategories = LocalData.filterNumberArrays(this.$packageKviRecommends.subcategories);
      return subCategories != null && subCategories.length > 0;
    }

    get isFormatSelected(): boolean {
        const formats = LocalData.filterNumberArrays(this.$packageKviRecommends.formatSelected);
        return formats != null && formats.length > 0;
    }

    get isRegionsSelected(): boolean {
        const regions = LocalData.filterNumberArrays(this.$packageKviRecommends.regionSelected);
        return regions != null && regions.length > 0;
    }

    get marginalProfitDeclinePcValidate(): boolean {
        const declineProfitabilityPc = this.$kviCart.declineProfitabilityPc;
        return declineProfitabilityPc != null && declineProfitabilityPc < 100;
    }

    get isLoadParamsBtnDisabled(): boolean {
        return this.cartInRoundingTab.id === -1;
    }

    get isSaveParamsBtnDisabled(): boolean {
        return (!this.marketForRoundingTab || !this.marketForRoundingTab.id || this.cartInRoundingTab.id === -1);
    }

    get isUploadRulesButtonDisabled(): boolean {
        return (!this.marketForRoundingTab || this.marketForRoundingTab.id === -1) || this.cartInRoundingTab.id === -1 || !this.file;
    }

    tryFindRulesParams(dontShowMessage: boolean = false) {
        if (this.marketForRoundingTab && this.marketForRoundingTab.id !== -1 && this.cartInRoundingTab.id !== -1) {
            this.httpFindKviRulesParams({
                tradingId: this.marketForRoundingTab.id,
                kviCartId: this.cartInRoundingTab.id,
            })
                .then((r) => {
                    this.roundingParams = {
                        pennies: r.data.pennies,
                        allNewPricesWithoutPennies: r.data.allNewPricesWithoutPennies,
                        manualPennies: r.data.manualPennies,
                        bigDigit: r.data.bigDigit,
                        randomPennies: r.data.randomPennies,
                        roundKviCompetitorPrice: r.data.roundKviCompetitorPrice,
                        roundPricesWithEqualCompStrategy: r.data.roundPricesWithEqualCompStrategy,
                    };

                    if (!dontShowMessage) {
                        this.showInfo(this.$t('kviCarts.messages.roundingParamsLoaded') as string);
                    }
                })
                .catch((e) => {
                    this.$log.error('Error occurred while loading rounding params for cart', e);
                    this.showError(this.$t('kviCarts.messages.errorLoadRoundingParams') as string);
                })
        }
    }

    async saveKviRulesParams() {
        const params: KviRoundingParams = {
            tradingId: this.marketForRoundingTab!.id,
            kviCartId: this.cartInRoundingTab.id,
            ...this.roundingParams,
            manualPennies: !this.roundingParams.allNewPricesWithoutPennies && this.roundingParams.manualPennies ? this.roundingParams.manualPennies : null,
            bigDigit: this.roundingParams.pennies && this.roundingParams.bigDigit ? this.roundingParams.bigDigit : null,
        }

        this.httpSaveKviRulesParams(params)
            .then((r) => {
                this.$log.debug('Параметры сохранены', r.data);
                this.showInfo(this.$t('kviCarts.messages.paramsSaved') as string);
            })
            .catch((e) => {
                this.showError(this.$t('kviCarts.messages.errorSaveRoundingParams') as string + e);
            })
    }

    replaceTxtToNumberForRoundingRules(value?: string) {
        if (value == null) {
            return null
        } else {
            return value.replace(/[^\d]/g, '');
        }
    }

    uploadRoundingFile() {
        const uploadFile = new FormData();

        uploadFile.append('file', new Blob([this.file!]), this.file!.name);

        const filters: KviRoundingParams = {
            tradingId: this.marketForRoundingTab!.id,
            kviCartId: this.cartInRoundingTab.id,
            allNewPricesWithoutPennies: this.roundingParams.allNewPricesWithoutPennies,
            pennies: this.roundingParams.pennies,
            randomPennies: this.roundingParams.randomPennies,
            roundKviCompetitorPrice: this.roundingParams.roundKviCompetitorPrice,
            roundPricesWithEqualCompStrategy: this.roundingParams.roundPricesWithEqualCompStrategy,
            bigDigit: this.roundingParams.pennies && this.roundingParams.bigDigit ? this.roundingParams.bigDigit : null,
            manualPennies: !this.roundingParams.allNewPricesWithoutPennies && this.roundingParams.manualPennies ? this.roundingParams.manualPennies : null,
        };

        uploadFile.append('filters', new Blob([JSON.stringify(filters)], {type: 'application/json'}));

        this.httpUploadKviRoundingRule(uploadFile, () => {})
            .then(() => {
                (this.$refs.fileInput as BFormFile).reset();

                this.file = null;

                this.showInfo(this.$t('kviCarts.messages.fileUploaded') as string);

                this.fetchRulesList(1);
            })
            .catch((e) => {
                (this.$refs.fileInput as BFormFile).reset();
                const dataWithoutStatus = e.response.data.replace(/[0-9]/g, '');
                this.showError(this.$t('kviCarts.messages.errorUploadFile') as string + ' ' + dataWithoutStatus);
                this.file = null;
            });
    }

    updateKviCartInRoundingTab(cart: SelectKviCart) {
        this.cartInRoundingTab = cart;

        this.tryFindRulesParams(true);

        this.fetchRulesList(1);
    }


    updateSelectMarketForRoundingTab(market: SelectMarket) {
        if (this.marketForRoundingTab === null || (this.marketForRoundingTab && this.marketForRoundingTab.id !== market.id)) {
            this.marketForRoundingTab = market;

            this.cartInRoundingTab = { id: -1, kviCartName: this.$t('kviCarts.labels.selectCartFull') as string };

            this.kviCartComponentKeyInRoundingTab++;

            localStorage.setItem('KviRoundingSelectMarket', JSON.stringify(this.marketForRoundingTab));

            this.paginationInRulesTable.total = 0;
            this.paginationInRulesTable.current = 1;
            this.rulesTableItems = [];
        }
    }

    downloadRoundingRulesFile(fileId: number) {
        this.isDownloadFileBtnLoading = true;

        this.$http.get('/api/file/download-rules-kvi-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId: fileId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.$t('kviCarts.downloads.rules') as string);
                document.body.appendChild(link);
                link.click();
            })
            .catch(() => {
                this.showError(this.$t('kviCarts.messages.errorDownloadRules') as string);
            })
            .finally(() => {
                this.isDownloadFileBtnLoading = false;
            });
    }

    beforeDeleteFileDialog(fileId: number) {
        this.fileIdForDelete = fileId;
        this.showDeleteFileModal = true;
    }

    showDeleteFileDialog(ruleId: number) {
        this.isDeleteFileBtnLoading = true;

        this.httpDeleteKviRoundingRulesFile(ruleId).then(() => {
            this.fetchRulesList(1);
        }).finally(() => {
            this.isDeleteFileBtnLoading = false;
        });
    }

    downloadRoundingErrorFile(ruleId: number) {
        this.isDownloadErrorsBtnLoading = true;

        this.$http.get('/api/file/download-rules-kvi-error-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.$t('kviCarts.downloads.errors') as string);
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                this.showError(this.$t('kviCarts.messages.errorDownloadErrors') as string);
            })
            .finally(() => {
                this.isDownloadErrorsBtnLoading = false;
            });
    }

    fetchRulesList(currentPage?: number) {
        if (currentPage) {
            this.paginationInRulesTable.current = currentPage;
        }

        const offset = (this.paginationInRulesTable.current - 1) * this.paginationInRulesTable.pageSize;

        const filter: KviRoundingRulesFilter = {
            tradingId: this.marketForRoundingTab!.id,
            kviCartId: this.cartInRoundingTab.id,
            dateBefore: this.rulesDateRange[0],
            dateAfter: this.rulesDateRange[1],
            userFio: this.selectUserFio !== 'All' ? this.selectUserFio : null,
        };

        this.isRulesTableLoading = true;

        this.httpLoadKviRoundingRules(filter, this.paginationInRulesTable.pageSize, offset)
            .then((res) => {
                this.paginationInRulesTable.total = res.data.totalElements;
                this.rulesTableItems = res.data.content;
             })
            .catch((e) => {
                this.showError(this.$t('kviCarts.messages.errorUploadRoundingRules') as string);
                console.error(e);
            })
            .finally(() => {
                this.isRulesTableLoading = false;
            });
    }

    onRulesTableChange(pagination: any) {
        const pager = {...this.paginationInRulesTable};
        pager.current = pagination.current;
        this.paginationInRulesTable = pager;

        this.fetchRulesList();
    }

    handleResetFiltersInRoundingTable() {
        this.rulesDateRange = [];
        this.selectUserFio = {value: 'All', label: this.$t('shared.boolFilter.all') as string}.value;
        this.usersFioList = [];

        this.fetchRulesList();
    }
  }
